"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncTerminalLogLevel = exports.SyncFiscalJournalVoidedContext = exports.TERMINAL_FISCAL_JOURNAL_VOIDED_ACTION = exports.SyncAuditLogUploadResponse = exports.SyncAuditLogUploadRequest = exports.SyncAuditLogRecord = exports.SyncReversalsResponse = exports.SyncReversalRecord = exports.SyncWeightStandardsResponse = exports.SyncWeightStandardRecord = exports.SyncPromotionsResponse = exports.SyncPromotionRecord = exports.SyncRegistersResponse = exports.SyncRegisterRecord = exports.SyncLocationsResponse = exports.SyncLocationRecord = exports.SyncCashiersResponse = exports.SyncCashierRecord = exports.SyncTaxRatesResponse = exports.SyncTerminalConfigResponse = exports.TerminalConfig = exports.TerminalCatalogueScopeConfig = exports.TerminalLoyaltyConfig = exports.TerminalFiscalConfig = exports.TerminalTaxRulesConfig = exports.TerminalTaxGroup = exports.TerminalCashRoundingConfig = exports.SyncCountryPackResponse = exports.SyncReceiptConfigResponse = exports.SyncI18nResponse = exports.SyncI18nDeleteIdentity = exports.SyncI18nString = exports.SyncCatalogHotkeysResponse = exports.SyncPricesResponse = exports.SyncPriceListSummary = exports.SyncPriceDeltaItem = exports.SyncPriceRecord = exports.SyncCatalogResponse = exports.SyncCatalogDeltaItem = exports.SyncCatalogPayload = exports.SyncHandshakeResponse = exports.RenewTerminalTokenResponse = exports.SyncAuthState = exports.SyncCapabilityState = exports.SyncBatchAck = exports.SyncRecordAck = exports.SyncChangeKind = exports.SYNC_PAGE_SIZE_MAX = exports.SYNC_PAGE_SIZE_DEFAULT = exports.SyncCursor = void 0;
exports.SyncAgeVerificationsUploadRequest = exports.SyncAgeVerificationRecord = exports.SyncShiftEventsUploadResponse = exports.SyncShiftEventsUploadRequest = exports.SyncShiftEventRecord = exports.SyncFiscalJournalUploadResponse = exports.SyncFiscalJournalUploadRequest = exports.SYNC_FISCAL_JOURNAL_BATCH_MAX = exports.SyncFiscalJournalRecord = exports.SYNC_FISCAL_JOURNAL_TEXT_MAX = exports.SyncFiscalJournalZTotals = exports.SyncFiscalJournalZPayment = exports.SyncFiscalJournalZTaxGroup = exports.SyncFiscalJournalZLine = exports.SyncFiscalJournalOfflineSession = exports.SyncFiscalJournalFiscal = exports.SyncFiscalJournalDocumentType = exports.SyncTransactionsUploadResponse = exports.SyncTransactionsUploadRequest = exports.SyncTransactionRecord = exports.SyncOsrOfflineEntry = exports.SYNC_OSR_ORIGIN_BINDINGS = exports.SYNC_OSR_LOYALTY_POST_PROCESSING_OFFLINE = exports.SYNC_OSR_OFFLINE_ACTION_BONUSES = exports.SYNC_OSR_OFFLINE_ACTION_FISCAL_STATUS = exports.SyncOsrOrder = exports.SYNC_OSR_EXTENSION = exports.SyncCrmVoucher = exports.LoyaltyIdentification = exports.LoyaltyCardVerification = exports.SyncTransactionApprover = exports.SyncTransactionPayment = exports.CardTransactionReference = exports.SyncReturnReason = exports.SyncTransactionLine = exports.SyncTelemetryUploadResponse = exports.SyncTelemetryUploadRequest = exports.TERMINAL_CAPABILITY_PROMOTION_BUY_X_GET_Y = exports.SyncTelemetryRecord = exports.SyncTelemetryDomainState = exports.SecureScaleCopyTelemetryHealth = exports.SecureScaleCopyLastSyncFact = exports.SecureScaleCopyCheckingFact = exports.SecureScaleCopyVersionFact = exports.KitchenTelemetryHealth = exports.KitchenPrinterHealth = exports.KitchenBrokerHealth = exports.SyncTerminalLogsUploadResponse = exports.SyncTerminalLogsUploadRequest = exports.SyncTerminalLogRecord = void 0;
exports.DEPRECATED_SYNC_DOMAIN_ALIASES = exports.SYNC_DOMAINS = exports.ListKitchenOrdersResponse = exports.KitchenOrderEventView = exports.KitchenOrderSummary = exports.SyncKitchenOrderEventsUploadResponse = exports.SyncKitchenOrderEventsUploadRequest = exports.SyncKitchenOrderEventRecord = exports.KitchenOrderEventLine = exports.KitchenOrderEventStatus = exports.SyncLagSnapshot = exports.SyncLagKitchenState = exports.SyncLagDomainState = exports.SyncLagLevel = exports.SyncNotImplementedResponse = exports.SYNC_APPROVALS_BATCH_MAX = exports.SyncApprovalRequestsUploadResponse = exports.SyncApprovalRequestsUploadRequest = exports.SyncWeightSamplesUploadResponse = exports.SyncWeightSamplesUploadRequest = exports.SyncWeightSampleRecord = exports.SyncAgeVerificationsUploadResponse = void 0;
exports.loyaltyIdentificationOf = loyaltyIdentificationOf;
exports.syncOsrOrderOf = syncOsrOrderOf;
exports.syncOsrPostProcessingOf = syncOsrPostProcessingOf;
const zod_1 = require("zod");
const terminal_js_1 = require("./terminal.js");
const country_pack_js_1 = require("./country-pack.js");
const terminal_peripheral_config_js_1 = require("./terminal-peripheral-config.js");
const tax_rates_js_1 = require("./tax-rates.js");
const receipt_config_js_1 = require("./receipt-config.js");
const pricing_js_1 = require("./pricing.js");
const catalog_hotkeys_js_1 = require("./catalog-hotkeys.js");
const cashier_js_1 = require("./cashier.js");
const approvals_js_1 = require("./approvals.js");
const terminal_params_js_1 = require("./terminal-params.js");
/**
 * Sync protocol v1 contracts (TRS §11). The source of truth for both
 * the BOS sync module and the cross-repo Flutter Sync Engine. Every
 * endpoint envelope, ack shape, cursor, dead-letter wrapper, and
 * idempotency-key field lives here.
 *
 * **Versioning.** The protocol version is negotiated separately via
 * `GET /sync/handshake` (see `apps/bos/docs/modules/sync.md` and
 * TRS §24.2). This file ships the v1.0 envelope shapes; minor bumps
 * add optional fields here without breaking existing terminals.
 *
 * **Domains.** TRS §11.2 enumerates 16 endpoints — 6 uploads
 * (transactions, shift-events, age-verifications, weight-samples,
 * telemetry, audit-log) + 9 downloads (catalog, prices, promotions,
 * cashiers, weight-standards, country-pack/{id}, terminal-config,
 * i18n, receipt-config) + 1 handshake. Even domains whose underlying
 * BOS implementation isn't ready yet (transactions, shifts, weight
 * standards, etc.) get their envelopes filed here so terminals can
 * compile against a stable contract.
 */
// ---------- Cursor + envelope primitives ----------
/**
 * Per-domain cursor handed back by every download endpoint and
 * passed back on the next call. Encoded as an opaque string —
 * terminals MUST NOT parse it. Currently a base64url JSON of
 * `{ updatedAt: ISO, id: string }` but this is implementation
 * detail; future server-side optimisations may switch to a
 * server-issued counter without changing the wire shape.
 */
exports.SyncCursor = zod_1.z.string().min(1).max(2048);
/**
 * H-83: money fields use the shared `MoneyMinor` regex from
 * `pricing.ts` — `^-?\d+$` matches integer minor units in a
 * base-10 string. Convention is smallest currency unit per
 * ISO-4217 ("199" = €1.99 for EUR, "100" = ₴1.00 for UAH);
 * negative values represent refunds / outflows. Pinning the regex
 * now (rather than later) avoids a contract regression for v1.0
 * terminals already in the wild.
 */
/**
 * Generic delta envelope shape returned by every download endpoint.
 * `cursor` is the cursor to pass back on the *next* call. `hasMore`
 * is true when the page was capped at `pageSize` and the server
 * still has more — terminals SHOULD continue calling immediately
 * with the new cursor in that case.
 */
function deltaEnvelope(itemSchema) {
    return zod_1.z.object({
        items: zod_1.z.array(itemSchema),
        cursor: exports.SyncCursor,
        hasMore: zod_1.z.boolean(),
        /**
         * Optional count of records available from the cursor supplied on this
         * request. Integrations request it only on their first page so a long pull
         * can expose numeric progress without making every terminal poll execute a
         * count query.
         */
        totalItems: zod_1.z.number().int().nonnegative().optional(),
        /**
         * Server-side timestamp of the snapshot point this page reflects.
         * Surfaced for terminal-side staleness display only — terminals
         * MUST use `cursor` (not this field) for resumption.
         */
        snapshotAt: zod_1.z.string().datetime(),
    });
}
/**
 * Default page size for download endpoints. Servers MAY send fewer.
 * Terminals SHOULD respect a `?pageSize=` they pass back; servers
 * cap at SYNC_PAGE_SIZE_MAX.
 */
exports.SYNC_PAGE_SIZE_DEFAULT = 500;
exports.SYNC_PAGE_SIZE_MAX = 5000;
// ---------- Per-record idempotency + delete tombstones ----------
/**
 * Every download record carries one of three change kinds. `delete`
 * records are tombstones — the server reports the deletion with the
 * `id` and the terminal removes the row locally. Tombstones are
 * retained for 30 days (TRS §11.5 implication); a terminal offline
 * longer than that must do a full re-bootstrap, not a delta pull.
 */
exports.SyncChangeKind = zod_1.z.enum(['create', 'update', 'delete']);
function deltaItem(payloadSchema) {
    return zod_1.z.discriminatedUnion('kind', [
        zod_1.z.object({ kind: zod_1.z.literal('create'), id: zod_1.z.string(), payload: payloadSchema }),
        zod_1.z.object({ kind: zod_1.z.literal('update'), id: zod_1.z.string(), payload: payloadSchema }),
        zod_1.z.object({ kind: zod_1.z.literal('delete'), id: zod_1.z.string() }),
    ]);
}
// ---------- Upload ack envelope ----------
/**
 * Each uploaded record gets a per-record ack. `accepted=true` means the
 * server has durably accounted for the record and the terminal may drop it
 * from its queue. Usually that means the exact record was persisted and a
 * `serverId` is present. A latest-snapshot stream such as telemetry may
 * instead return `code=SUPERSEDED` with no `serverId` when a newer snapshot
 * is already stored; retrying the older snapshot could never improve state.
 * `accepted=false` with `retriable=true` ⇒ transient, terminal
 * retries with backoff. `accepted=false` with `retriable=false` ⇒
 * permanent, terminal moves to local dead-letter (TRS §11.7).
 *
 * `code` is a stable machine-readable identifier (`AUTH_REVOKED`,
 * `VALIDATION_FAILED`, `DUPLICATE_REJECTED`, etc.). Codes are
 * additive within v1; a terminal that doesn't recognise a code
 * treats `retriable` as authoritative.
 */
exports.SyncRecordAck = zod_1.z.object({
    /** The terminal-supplied client UUID echoed back. */
    clientUuid: zod_1.z.string().min(1).max(64),
    accepted: zod_1.z.boolean(),
    /** Server id when this exact record was persisted; omitted when superseded. */
    serverId: zod_1.z.string().optional(),
    /** Machine-readable outcome/error code (`SUPERSEDED` may accompany acceptance). */
    code: zod_1.z.string().optional(),
    /** Human-readable hint for cashier-visible UI. Localisable. */
    message: zod_1.z.string().optional(),
    /** Whether the terminal should retry. Always present on rejection. */
    retriable: zod_1.z.boolean().optional(),
});
exports.SyncBatchAck = zod_1.z.object({
    receivedAt: zod_1.z.string().datetime(),
    acks: zod_1.z.array(exports.SyncRecordAck),
    /**
     * If non-zero, count of records whose retriable=false. The
     * terminal moves these to its local dead-letter queue. Reported
     * separately for telemetry visibility (TRS §11.8 sync-lag UI is
     * the read path).
     */
    permanentlyRejected: zod_1.z.number().int().min(0),
});
// ---------- Handshake (TRS §24.2) ----------
/** Capability state per `/sync/*` domain — see `apps/bos/docs/modules/sync.md`. */
exports.SyncCapabilityState = zod_1.z.enum(['ready', 'deferred', 'deferred-501']);
/**
 * Terminal credential state, reported on every handshake (RFL-300).
 *
 * Terminal tokens are long-lived and there was no way to replace one
 * short of a physical re-activation, so both of the ways a token stops
 * working were silent until they had already happened:
 *
 *  - it **expires** — the lifetime is fixed at activation, and an expired
 *    token cannot be presented for renewal, so this MUST be acted on in
 *    advance;
 *  - its **key version** is superseded by a rotation — the previous
 *    version keeps verifying while the grace pair is open, which is
 *    exactly the window in which renewal is possible.
 *
 * Both are reported here, on an already-authenticated response the
 * terminal reaches every sync cycle. Signalling on the 401 instead would
 * have been useless for expiry: by then the token no longer verifies and
 * there is nothing left to present.
 */
exports.SyncAuthState = zod_1.z.object({
    /** The tenant's current JWT key version. */
    keyVersion: zod_1.z.number().int().min(0),
    /** Key version of the token that authenticated this request. */
    tokenKeyVersion: zod_1.z.number().int().min(0),
    /** Expiry of the presented token. */
    expiresAt: zod_1.z.string().datetime(),
    /**
     * The terminal should call the renewal endpoint. True when the token is
     * approaching expiry, or when a rotation has moved past its key
     * version and the grace pair will not stay open forever.
     */
    renewalRecommended: zod_1.z.boolean(),
    /** Why, for the terminal's log. Absent when no renewal is needed. */
    renewalReason: zod_1.z.enum(['expiring', 'key-rotated']).optional(),
});
/**
 * Response to a terminal token renewal (RFL-300).
 *
 * Deliberately the same shape the activation flow returns, minus the
 * profile: a terminal that can store a token from activation can store
 * one from here without a second code path.
 */
exports.RenewTerminalTokenResponse = zod_1.z.object({
    accessToken: zod_1.z.string().min(1),
    expiresAt: zod_1.z.string().datetime(),
    keyVersion: zod_1.z.number().int().min(0),
});
const SyncHandshakeResponseBase = zod_1.z.object({
    /** Agreed protocol version (highest both sides support). */
    protocol: zod_1.z.object({ major: zod_1.z.number().int().min(0), minor: zod_1.z.number().int().min(0) }),
    /**
     * What this BOS supports. `minorRange.max` is the BOS's minor;
     * `min` is `max - SUPPORTED_MINOR_WINDOW` (TRS §24.2 default 2).
     */
    supported: zod_1.z.object({
        major: zod_1.z.number().int().min(0),
        minorRange: zod_1.z.object({
            min: zod_1.z.number().int().min(0),
            max: zod_1.z.number().int().min(0),
        }),
    }),
    bos: zod_1.z.object({
        appVersion: zod_1.z.string().min(1),
        /** CI-supplied build id; `dev` in unstamped local builds. */
        buildId: zod_1.z.string().min(1),
    }),
    /**
     * Who authenticated this handshake, when that is a terminal.
     *
     * Optional because `/sync/handshake` also serves the read-only service
     * principal (RFL-344), which has no terminal identity, no app version and
     * no profile. A terminal ALWAYS receives this object — the field is
     * absent only for a service caller — so no terminal release is required.
     */
    terminal: zod_1.z
        .object({
        /** Echoed from `X-Terminal-App-Version`; null on missing/malformed. */
        appVersion: zod_1.z.string().nullable(),
        id: zod_1.z.string(),
        /**
         * The store (BOS location) the terminal is bound to right now, or
         * null when it is bound to none (SSC-188). Activation returns it
         * once; the handshake repeats it every sync cycle so a terminal
         * moved to another store notices without re-activation. Optional so
         * a terminal can still read a BOS that predates it.
         */
        locationId: zod_1.z.string().nullable().optional(),
        /** SSC-229: independently authenticated binding for replica scope. */
        tenantId: zod_1.z.string().min(1).optional(),
        secureScaleEnabled: zod_1.z.boolean().optional(),
    })
        .optional(),
    /**
     * Who authenticated this handshake, when that is a service principal
     * (RFL-344). Absent for terminals. Carries the granted scopes so an
     * integration can verify what it actually holds instead of inferring it
     * from which calls 403.
     */
    service: zod_1.z
        .object({
        id: zod_1.z.string(),
        scopes: zod_1.z.array(zod_1.z.string()),
    })
        .optional(),
    /** Per-domain capability map (`sync.<domain>` → state). */
    capabilities: zod_1.z.record(zod_1.z.string(), exports.SyncCapabilityState),
    /**
     * Credential state for the token that authenticated THIS request
     * (RFL-300). Optional so a terminal predating renewal support keeps
     * working — and so a BOS that predates it does not fail a newer
     * terminal's schema check.
     *
     * The server does the comparison rather than exposing raw material for
     * the terminal to reason about. That is deliberate: renewal policy —
     * how close to expiry is too close, whether a key-version gap is urgent
     * — then lives on the server, where it can change in a deploy, instead
     * of inside a till application that ships by OTA on its own schedule.
     * The terminal only has to obey a boolean.
     */
    auth: exports.SyncAuthState.optional(),
});
exports.SyncHandshakeResponse = SyncHandshakeResponseBase.superRefine((handshake, ctx) => {
    const principalCount = Number(handshake.terminal !== undefined) + Number(handshake.service !== undefined);
    if (principalCount !== 1) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['terminal'],
            message: 'handshake must contain exactly one of terminal or service',
        });
    }
});
// ---------- Download — Catalog (Sprint 1+ data exists) ----------
exports.SyncCatalogPayload = zod_1.z.union([terminal_js_1.CatalogBootstrapItem, terminal_js_1.CatalogBootstrapCategory]);
/**
 * The catalog delta endpoint emits two record subtypes — items and
 * categories — interleaved. The discriminator lives at the wrapping
 * level (`kind: 'item' | 'category'`) since the inner shapes don't
 * share a discriminator field.
 */
exports.SyncCatalogDeltaItem = zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({
        kind: zod_1.z.literal('item.create'),
        id: zod_1.z.string(),
        payload: terminal_js_1.CatalogBootstrapItem,
    }),
    zod_1.z.object({
        kind: zod_1.z.literal('item.update'),
        id: zod_1.z.string(),
        payload: terminal_js_1.CatalogBootstrapItem,
    }),
    zod_1.z.object({ kind: zod_1.z.literal('item.delete'), id: zod_1.z.string() }),
    zod_1.z.object({
        kind: zod_1.z.literal('category.create'),
        id: zod_1.z.string(),
        payload: terminal_js_1.CatalogBootstrapCategory,
    }),
    zod_1.z.object({
        kind: zod_1.z.literal('category.update'),
        id: zod_1.z.string(),
        payload: terminal_js_1.CatalogBootstrapCategory,
    }),
    zod_1.z.object({ kind: zod_1.z.literal('category.delete'), id: zod_1.z.string() }),
]);
exports.SyncCatalogResponse = deltaEnvelope(exports.SyncCatalogDeltaItem);
// ---------- Download — Prices (Sprint 1 data exists) ----------
exports.SyncPriceRecord = zod_1.z.object({
    itemId: zod_1.z.string(),
    /**
     * Narrows this price to ONE barcode of [itemId] (YUKI-2). Null — the case
     * for every deployment before this — prices the item as a whole.
     *
     * Some retailers price the barcode rather than the SKU: one item code, many
     * barcodes, different prices. Modelled as a narrowing of the existing key
     * rather than a separate barcode-price domain, so a catalogue that mixes
     * both resolves in one pass and an item with no barcode-level price behaves
     * exactly as it did before.
     *
     * Resolution is most-specific-wins: a record matching the scanned barcode
     * beats the item-level record. Consumers that do not implement this MUST
     * ignore rows where it is non-null rather than treat them as item-level —
     * otherwise the last barcode row read silently becomes the item's price.
     */
    barcode: zod_1.z.string().min(1).max(64).nullable().default(null),
    priceListId: zod_1.z.string(),
    unitPriceMinor: pricing_js_1.MoneyMinor,
    /**
     * RL-994 — the 3-decimal price per litre of a fuel item, in thousandths of
     * the currency unit: "1579" is 1.579. A decimal digit string, 1..9 999 999,
     * or null when no 3-decimal price was entered. It is never derived from
     * `unitPriceMinor`, so null means "no fuel price set". When set,
     * `unitPriceMinor` is round-half-up(milli / 10) for every cents reader.
     * Older Back Office builds omit it; the terminals' FUEL_API.md is the reader.
     */
    unitPriceMilli: zod_1.z
        .string()
        .regex(/^[1-9][0-9]{0,6}$/)
        .nullable()
        .default(null),
    /** Cost minor — null when not tracked. */
    costMinor: pricing_js_1.MoneyMinor.nullable(),
    /**
     * VIP price for this price row (RFL-344) — null when not set. When
     * [barcode] is non-null, the value is narrowed to that barcode.
     *
     * **The Yuki terminal composition applies this** (YUKI-263); other terminal
     * compositions may ignore it. That reverses what this comment
     * said from RFL-344 until 2026-09-14, which was that the field was advisory
     * and a terminal MUST NOT act on it because eligibility lived in loyalty.
     * The reversal is deliberate, not drift: on the Yuki estate the price is
     * charged at the till, from this field, and the rules are
     *
     *   - it applies only to a card the loyalty service CONFIRMED ONLINE — the
     *     till cannot know a customer is a VIP while the link is down, so an
     *     offline or unconfirmed card pays `unitPriceMinor` (ADR-0016);
     *   - it is a PRICE and it ends pricing for that line: no promotion and no
     *     discount is applied on top of it;
     *   - it reaches the fiscal document and the GP export as the line's price,
     *     never as a reduction;
     *   - it is honoured even when it is HIGHER than `unitPriceMinor`. Some rows
     *     on the live estate are. It is the price; there is no best-of-two.
     *
     * Which card categories count as VIP is operator data, authored per estate
     * as the terminal parameter `loyalty.vipCategoryCodes` — not a constant, and
     * not something this wire decides.
     */
    vipPriceMinor: pricing_js_1.MoneyMinor.nullable(),
    /** ISO-4217 of the price-list. */
    currencyCode: zod_1.z.string().regex(/^[A-Z]{3}$/),
    /** When the entry becomes effective (NULL ⇒ already in effect). */
    effectiveFrom: zod_1.z.string().datetime().nullable(),
});
exports.SyncPriceDeltaItem = zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({ kind: zod_1.z.literal('create'), id: zod_1.z.string(), payload: exports.SyncPriceRecord }),
    zod_1.z.object({ kind: zod_1.z.literal('update'), id: zod_1.z.string(), payload: exports.SyncPriceRecord }),
    zod_1.z.object({
        kind: zod_1.z.literal('delete'),
        id: zod_1.z.string(),
        /**
         * Present on new BOS versions so integrations can retire a selected price
         * without retaining an unbounded price-entry-id index. Optional for wire
         * compatibility with older committed tombstones.
         */
        itemId: zod_1.z.string().optional(),
        priceListId: zod_1.z.string().optional(),
        /** Barcode narrowed by the retired price; null/absent is SKU-level. */
        barcode: zod_1.z.string().min(1).max(64).nullable().optional(),
    }),
]);
exports.SyncPriceListSummary = zod_1.z.object({
    id: zod_1.z.string(),
    currencyCode: zod_1.z.string().regex(/^[A-Z]{3}$/),
    isDefault: zod_1.z.boolean(),
    itemCount: zod_1.z.number().int().nonnegative(),
});
exports.SyncPricesResponse = deltaEnvelope(exports.SyncPriceDeltaItem).extend({
    /** Returned only with `includeTotal=true`; lets an integration select the
     * configured/default/most-populated base list before applying the first
     * price chunk. */
    priceLists: zod_1.z.array(exports.SyncPriceListSummary).optional(),
    /**
     * RL-837 — every price list this terminal's feed is drawn from, sorted and
     * without duplicates. Sent to terminal principals only; a service client
     * chooses its own scope and never receives it.
     *
     * - department bound to a list (RL-110) → exactly that list;
     * - no list bound → every list the unscoped feed delivers rows for (live or
     *   withdrawn). One list in the tenant gives one id; several give all.
     *
     * A terminal keeps one cached price per item and barcode and does not
     * record which list wrote it, so it may only apply a price `delete` when
     * this set has exactly one id and the tombstone's `priceListId` is that id.
     * The terminal remembers the last set it received; a different set means
     * its cache was built under another scope and it re-reads the whole feed
     * into a staging area. Cutover and intermediate-state safety are part of
     * the separately reviewed terminal implementation. Absent from an older
     * Back Office; a terminal then treats the
     * scope as unknown and applies no price deletes.
     */
    servedPriceListIds: zod_1.z.array(zod_1.z.string().min(1)).optional(),
});
// ---------- Download — Catalog Hotkeys (Sprint 4.7 data exists) ----------
/**
 * Sprint 4.7 hotkey-tree pull. Snapshot-shaped, not paged — the tree
 * is small (≤500 nodes, ~50 KB worst case). Terminals call with
 * `?since=<version>`; equal version → 304 Not Modified; older → 200
 * with the full tree at the new version.
 *
 * Same shape as `CatalogHotkeyTree` (re-exported for sync naming
 * symmetry with the other `Sync<Domain>Response` envelopes).
 */
exports.SyncCatalogHotkeysResponse = catalog_hotkeys_js_1.CatalogHotkeyTree;
// ---------- Download — i18n (Sprint 2+ data exists) ----------
exports.SyncI18nString = zod_1.z.object({
    // H-42: single source of truth for the terminal-facing surface set.
    surface: zod_1.z.enum(terminal_js_1.TERMINAL_I18N_SURFACES),
    localeCode: zod_1.z.string().regex(/^[a-z]{2,3}$/),
    key: zod_1.z.string().min(1),
    /** ICU MessageFormat template; empty string allowed for "translation pending". */
    value: zod_1.z.string(),
});
/** RL-528: immutable identity of the translation being retired. No value. */
exports.SyncI18nDeleteIdentity = exports.SyncI18nString.omit({ value: true });
exports.SyncI18nResponse = deltaEnvelope(zod_1.z.discriminatedUnion('kind', [
    zod_1.z.object({ kind: zod_1.z.literal('create'), id: zod_1.z.string(), payload: exports.SyncI18nString }),
    zod_1.z.object({ kind: zod_1.z.literal('update'), id: zod_1.z.string(), payload: exports.SyncI18nString }),
    // Optional only for compatibility with older hosts' id-only tombstones.
    zod_1.z.object({
        kind: zod_1.z.literal('delete'),
        id: zod_1.z.string(),
        payload: exports.SyncI18nDeleteIdentity.optional(),
    }),
]));
// ---------- Download — Receipt Config (Sprint 3 data exists) ----------
exports.SyncReceiptConfigResponse = zod_1.z.object({
    /**
     * Resolved effective receipt config for the calling terminal,
     * keyed by receipt type. Same shape as the bootstrap one-shot;
     * sync delta refreshes the snapshot when any contributing config
     * row (customer / location / terminal scope) changes.
     */
    effective: receipt_config_js_1.ReceiptConfigBootstrap,
    /** Cursor opaque — terminal calls back with this string. */
    cursor: exports.SyncCursor,
    /** Always false — receipt config is a single-row snapshot, not paged. */
    hasMore: zod_1.z.boolean(),
    snapshotAt: zod_1.z.string().datetime(),
});
// ---------- Download — Country Pack (Sprint 3 data exists) ----------
exports.SyncCountryPackResponse = zod_1.z.object({
    /** Full denormalised pack manifest — same shape as bootstrap. */
    manifest: country_pack_js_1.CountryPackManifest,
    /**
     * The version this terminal currently has cached. The endpoint is
     * not strictly cursor-based — pack updates are atomic, version-
     * pinned. Terminals call with `?version=<current>`; if BOS still
     * has that version, returns 304 (`notModified=true`). Otherwise
     * the new manifest comes back wholesale.
     */
    notModified: zod_1.z.boolean(),
});
// ---------- Download — Terminal Config (Sprint 2 data exists) ----------
/**
 * Terminal configuration authored in BOS (VL-135 / VL-136 / VL-171).
 *
 * Namespaced so a deployment configures only what it needs, and so the terminal
 * can adopt namespaces one at a time. An ABSENT namespace means "use the
 * terminal's own default" and is deliberately distinct from a namespace present
 * but disabled — `cash_rounding` absent is not the same as
 * `cash_rounding.enable_round_precision = false`.
 *
 * Rates are decimal STRINGS. A VAT rate that travels as a float is a rate that
 * can arrive as 19.999999999999998, and this value reaches a fiscal receipt.
 */
exports.TerminalCashRoundingConfig = zod_1.z
    .object({
    enable_round_precision: zod_1.z.boolean(),
    /** Minor units (kopecks). 50 = round to the nearest 0.50. */
    round_precision: zod_1.z.number().int().positive().max(100_000),
    rounding_error_message: zod_1.z.string().min(1).max(500).optional(),
    /**
     * RL-793 — rounding direction. Absent means `down`, which is the
     * behaviour every terminal had before this field existed (UA always
     * rounds down). `nearest` rounds to the nearest `round_precision` step
     * (LT). Delivered exactly as authored: BOS never injects a default, and
     * the terminals serialise it only when it is not `down`.
     */
    round_mode: zod_1.z.enum(['down', 'nearest']).optional(),
})
    .strict();
const TerminalTaxPercent = zod_1.z
    .string()
    .regex(/^(?:\d{1,3}(?:\.\d{1,2})?|1000(?:\.0{1,2})?)$/, 'a decimal percentage from "0" to "1000.00", with at most 2 decimal places');
exports.TerminalTaxGroup = zod_1.z
    .object({
    /** The Masterkasa group letter the fiscal device knows: "В", "Г", … */
    code: zod_1.z.string().min(1).max(8),
    vat_rate: TerminalTaxPercent.optional(),
    excise_rate: TerminalTaxPercent.optional(),
})
    .strict();
exports.TerminalTaxRulesConfig = zod_1.z
    .object({ tax_groups: zod_1.z.array(exports.TerminalTaxGroup).min(1).max(50) })
    .strict()
    .refine((config) => new Set(config.tax_groups.map((group) => group.code)).size === config.tax_groups.length, {
    message: 'tax group codes must be unique',
});
exports.TerminalFiscalConfig = zod_1.z
    .object({
    /** A binding id the terminal registry already understands (`ua-prro`, `lt-vmi-vf`). */
    bindingId: zod_1.z
        .string()
        .min(1)
        .max(64)
        .regex(/^[a-z0-9-]+$/, 'lowercase alphanumeric + dash'),
})
    .strict();
/**
 * YUKI-50 — where this estate's re:form.loyalty API lives.
 *
 * Addressing, not an operator setting: it is decided per deployment alongside
 * the country pack, and nobody at a till should meet it in a settings editor.
 * It rides terminal-config rather than the activation response so that moving
 * the loyalty host is picked up by a sync instead of requiring every terminal
 * to be re-paired.
 *
 * The **credential** is deliberately not here. It lives in the terminal's
 * OS-backed keystore and is entered on the terminal itself, because this
 * channel is BOS-authored, cached in the terminal database in clear, and
 * visible to anyone with BOS access.
 *
 * An absent `loyalty` namespace means the estate has no direct loyalty link,
 * which is the ordinary case for every deployment except Yuki, and which the
 * terminal reads as "disable the link" rather than as an error.
 */
exports.TerminalLoyaltyConfig = zod_1.z
    .object({
    /** Absolute base URL, e.g. `https://loyalty.example.com/api`. */
    base_url: zod_1.z
        .string()
        .url()
        .max(255)
        .superRefine((raw, context) => {
        let value;
        try {
            value = new URL(raw);
        }
        catch {
            // `.url()` owns the ordinary invalid-URL issue. Zod still runs this
            // refinement after that failure, so do not turn safeParse into a
            // throw while adding the endpoint-specific checks below.
            return;
        }
        if (value.protocol !== 'https:') {
            context.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'loyalty base URL must use HTTPS',
            });
        }
        if (value.username !== '' || value.password !== '') {
            context.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'loyalty base URL must not contain credentials',
            });
        }
        if (value.search !== '' || value.hash !== '') {
            context.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: 'loyalty base URL must not contain a query or fragment',
            });
        }
    }),
})
    .strict();
/**
 * VL-166 — which part of the catalogue this terminal sells.
 *
 * Per terminal, not per till type: a self-checkout lane, an express lane and a
 * staffed till in the same store may each be authored to sell something
 * different. Decided as a SELECTOR the terminal applies locally (operator
 * decision, 2026-08-05) rather than as server-side filtering: Back Office keeps
 * sending the superset, so a till can tell "not sold at this terminal" apart
 * from "unknown barcode" and say which one it is.
 *
 * `store_catalogue_price_list_id` scopes the store catalogue feed
 * (`GET /sync/store-catalogue`): it is the `VarusCatalogueBarcode.priceListId`
 * the terminal may sell from. A barcode present in the feed only under other
 * lists is known but not sellable here. Named for that feed on purpose — the
 * shared catalogue's price lists are ids of a different kind, and giving the
 * two one field would let a value authored for one be read as the other.
 *
 * An ABSENT namespace keeps the terminal's own default, the main list `0`, so
 * every terminal authored before this namespace existed sells exactly what it
 * sold before. Assortment subsets are not selectable yet: there
 * is no assortment entity to name, and inventing its id here would fix a
 * contract before its concept.
 */
exports.TerminalCatalogueScopeConfig = zod_1.z
    .object({
    // Keep this in the same range as the published store-catalogue
    // priceListId: the connector accepts any non-negative safe integer. A
    // narrower selector would make a valid list impossible to sell from.
    store_catalogue_price_list_id: zod_1.z.number().int().min(0).max(Number.MAX_SAFE_INTEGER),
})
    .strict();
exports.TerminalConfig = zod_1.z
    .object({
    cash_rounding: exports.TerminalCashRoundingConfig.optional(),
    tax_rules: exports.TerminalTaxRulesConfig.optional(),
    fiscal: exports.TerminalFiscalConfig.optional(),
    loyalty: exports.TerminalLoyaltyConfig.optional(),
    catalogue_scope: exports.TerminalCatalogueScopeConfig.optional(),
})
    .strict();
exports.SyncTerminalConfigResponse = zod_1.z.object({
    profile: terminal_js_1.TerminalProfileSummary,
    /**
     * Profile config merged with any per-terminal override. Always present;
     * `{}` means nothing is configured, which every deployment before VL-135
     * means and which the terminal must treat as "use my defaults".
     */
    config: exports.TerminalConfig,
    /**
     * RFL-238 — the terminal's hardware, resolved server-side (RFL-242).
     *
     * A sibling of `config` rather than a namespace inside it because that is
     * where the terminal has been reading it since RFL-337: `TerminalConfigSnapshot`
     * parses a top-level `peripherals` object and distinguishes an ABSENT field
     * from an explicitly empty one. Absent means an older Back Office made no
     * hardware statement and the till keeps its build defines; `{}` means an
     * operator deliberately cleared the authored settings.
     *
     * Always the RESOLVED value — group defaults collapsed with the per-terminal
     * override. Nothing here models inheritance: a terminal that had to resolve
     * the cascade itself would need the group data too, and two implementations
     * of one precedence rule is how a lane ends up talking to the wrong port.
     */
    // Optional while older Back Office versions remain in a rolling fleet.
    // The current endpoint still always emits this field.
    peripherals: terminal_peripheral_config_js_1.TerminalPeripheralConfig.optional(),
    /** Profile binding to a country pack — null when unbound. */
    countryPackId: zod_1.z.string().nullable(),
    /**
     * Which register this is inside its own store — GP's `POSNr` (YUKI-197).
     *
     * Authored in Back Office and delivered here so the terminal holds its own
     * store number rather than only Back Office knowing it. Null when nobody has
     * set one: a store number is not derivable, and defaulting it to 1 or to the
     * export id would print a confident wrong answer into a reconciliation the
     * operator cannot check.
     *
     * Optional on the wire while older Back Office versions remain in a rolling
     * fleet; the current endpoint always emits it.
     */
    posNrInStore: zod_1.z.number().int().positive().nullable().optional(),
    /**
     * The register number the store's own system knows this till by — the
     * "POS external number" authored on the terminals screen (VL-266), 3 to 5
     * digits. Not `posNrInStore`: a store's system may number its registers
     * across the chain (574), not from 1 inside the store (VL-340).
     *
     * Delivered so the till can name itself by the number the store uses.
     * Null when nobody has set one; the till shows it as not recorded rather
     * than guessing.
     *
     * Optional on the wire while older Back Office versions remain in a rolling
     * fleet; the current endpoint always emits it.
     */
    posExternalNumber: zod_1.z
        .string()
        .regex(/^[0-9]{3,5}$/)
        .nullable()
        .optional(),
    snapshotAt: zod_1.z.string().datetime(),
});
// ---------- Download — Tax Rates (delta variant; bootstrap exists) ----------
/**
 * Tax-rates sync emits the same flat `taxCategory → ratePercent`
 * map the bootstrap response uses, plus the underlying TaxRateActive
 * rows for terminals that want to track effective-from / activeUntil
 * windows directly. Always non-paged — the active row count per
 * pack is small (≤ ~10 categories).
 */
exports.SyncTaxRatesResponse = zod_1.z.object({
    /** Map view — same as bootstrap. */
    effective: tax_rates_js_1.TaxRatesBootstrap,
    /** Underlying active rows; useful for terminals that audit changes. */
    rates: zod_1.z.array(tax_rates_js_1.TaxRateActive),
    cursor: exports.SyncCursor,
    hasMore: zod_1.z.literal(false),
    snapshotAt: zod_1.z.string().datetime(),
});
// ---------- Download — Cashiers ----------
/**
 * Sprint 5.1b: the per-record wire shape is the canonical
 * `CashierSyncRecord` from `./cashier.ts` (single source of truth
 * with the Employees module spec). The original Sprint-4-filed
 * placeholder used `externalCode` + `permissions[]`; the live
 * Cashier model uses `employeeCode` and does NOT carry per-cashier
 * permissions in Sprint 5 (cashiers authenticate to terminals only;
 * BOS-user RBAC stays orthogonal per TRS §27 / employees spec
 * "Out of scope"). Re-exported here so existing consumers
 * (`SyncCashiersResponse`) keep working.
 */
exports.SyncCashierRecord = cashier_js_1.CashierSyncRecord;
exports.SyncCashiersResponse = deltaEnvelope(deltaItem(exports.SyncCashierRecord));
// ---------- Download — Retail estate (RFL-345, service principals) ----------
/**
 * A trading location. re:form Loyalty maps this to its `Store` (RFL-345;
 * contract §2.11), keyed on `code` → `Store.externalId`.
 *
 * These two feeds are for **service principals**, not terminals: a till has
 * no use for the estate directory, and an advertised domain is a scheduled
 * poll.
 *
 * `status` carries retirement — there is no tombstone kind on this feed.
 * Deletes deactivate rather than delete (contract §2.4), because a consumer's
 * historical records reference a store long after it stops trading.
 */
exports.SyncLocationRecord = zod_1.z.object({
    /** Stable external identifier, unique per deployment. */
    code: zod_1.z.string().min(1),
    name: zod_1.z.string().min(1),
    addressLine: zod_1.z.string().nullable(),
    city: zod_1.z.string().nullable(),
    region: zod_1.z.string().nullable(),
    postalCode: zod_1.z.string().nullable(),
    /**
     * ISO-3166 alpha-2, or null when the operator has not set one.
     *
     * NULL is consequential downstream rather than merely absent: loyalty
     * requires a configured country per store (currency, language, tax and
     * consent hang off it) and skips a location without one. A location that
     * never becomes a store is invisible unless someone looks.
     */
    countryCode: zod_1.z.string().nullable(),
    timezone: zod_1.z.string().nullable(),
    status: zod_1.z.enum(['active', 'archived']),
    /**
     * The price list this location's terminals sell from (RL-110), or null when
     * it has none. Page `/sync/prices?priceListId=` with it to get the store's
     * prices (SSC-89: SecureScale's substitution risk is priced per store).
     *
     * Optional so a consumer built before it keeps parsing.
     */
    priceListId: zod_1.z.string().nullable().optional(),
});
exports.SyncLocationsResponse = deltaEnvelope(deltaItem(exports.SyncLocationRecord));
/**
 * A till, as a member of the retail estate. re:form Loyalty maps this to its
 * `CashRegister` (RFL-345; contract §2.11).
 *
 * Distinct from `/sync/terminal-config`, which returns the CALLING terminal's
 * own profile. This feed is the directory of every terminal in the deployment.
 *
 * Carries no credential, fingerprint, heartbeat or network state — a register
 * directory needs identity and placement, and the rest is operational data a
 * catalogue consumer has no business holding.
 */
exports.SyncRegisterRecord = zod_1.z.object({
    code: zod_1.z.string().min(1),
    displayName: zod_1.z.string().min(1),
    kind: zod_1.z.enum(['pos', 'sco', 'attendant']),
    /**
     * The owning location's `code` — the join key, matching
     * `SyncLocationRecord.code`. Emitted alongside `locationId` because a
     * consumer keys its stores by code; an id-only payload would force a second
     * lookup and a mapping table to answer "which store is this register in".
     */
    locationCode: zod_1.z.string().nullable(),
    /** Internal id of the owning location; null when unassigned. */
    locationId: zod_1.z.string().nullable(),
    status: zod_1.z.enum(['provisioned', 'active', 'revoked']),
    /**
     * Whether Back Office has a bagging (security) scale configured for this
     * terminal: its effective peripheral configuration, the profile's merged
     * with the terminal's own override, carries a `baggingScale` block (SSC-89).
     *
     * It is what Back Office was told, not what the lane reports. Absent when
     * the stored configuration cannot be read. This is a delta on the
     * terminal row, so a change made on the profile alone arrives on the next
     * `snapshot=true` pull, not on the next delta.
     *
     * Optional so a consumer built before it keeps parsing.
     */
    baggingScale: zod_1.z.boolean().optional(),
});
exports.SyncRegistersResponse = deltaEnvelope(deltaItem(exports.SyncRegisterRecord));
// ---------- Download — Promotions (Sprint 10 — shape filed now) ----------
exports.SyncPromotionRecord = zod_1.z.object({
    id: zod_1.z.string(),
    code: zod_1.z.string().min(1).max(64),
    displayName: zod_1.z.string().min(1),
    /** Promo type — `bogo`, `discount_percent`, etc. Sprint 10 finalises. */
    kind: zod_1.z.string(),
    startsAt: zod_1.z.string().datetime().nullable(),
    endsAt: zod_1.z.string().datetime().nullable(),
    /** Opaque per-kind config — Sprint 10 narrows. */
    config: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    // The fields below are what the terminal's promotion engine reads
    // (YUKI-236). Optional so an older BOS page still parses; BOS sends them.
    scope: zod_1.z.enum(['line', 'basket', 'customer', 'tender']).optional(),
    priority: zod_1.z.number().int().optional(),
    couponCode: zod_1.z.string().nullable().optional(),
    exclusiveWithinBucket: zod_1.z.boolean().optional(),
    stackableWithCustomerDiscount: zod_1.z.boolean().optional(),
    excludesPromotionCodes: zod_1.z.array(zod_1.z.string()).optional(),
    /** `active` / `paused` — archived rows travel as delete tombstones. */
    status: zod_1.z.enum(['active', 'paused', 'archived']).optional(),
    version: zod_1.z.number().int().min(1).optional(),
    /** Card-category applicability; null = for everyone. */
    cardCategories: zod_1.z
        .object({ include: zod_1.z.array(zod_1.z.string()), exclude: zod_1.z.array(zod_1.z.string()) })
        .nullable()
        .optional(),
    /**
     * EAT-3: the till applies this rule only while it is online; offline it
     * skips the rule and re-prices the basket without it. BOS always sends it.
     *
     * Absent = `false`. A till built before EAT-3 does not know the field and
     * ignores it, so it APPLIES a flagged rule offline too — the accepted
     * behaviour until that till is upgraded. A reader that knows the field and
     * finds anything other than a boolean must treat the rule as online-only:
     * wrongly skipping a discount offline is cheaper than wrongly giving one.
     */
    onlineOnly: zod_1.z.boolean().optional(),
});
exports.SyncPromotionsResponse = deltaEnvelope(deltaItem(exports.SyncPromotionRecord));
// ---------- Download — Weight Standards (Sprint 8 — shape filed now) ----------
exports.SyncWeightStandardRecord = zod_1.z.object({
    id: zod_1.z.string(),
    itemId: zod_1.z.string(),
    expectedGrams: zod_1.z.number().int().positive(),
    toleranceGrams: zod_1.z.number().int().min(0),
    sampleCount: zod_1.z.number().int().min(0),
    updatedAt: zod_1.z.string().datetime(),
});
exports.SyncWeightStandardsResponse = deltaEnvelope(deltaItem(exports.SyncWeightStandardRecord));
// ---------- Download — Payment Reversals (Sprint 13.4) ----------
/**
 * Queued reversal from BOS that the terminal must replay against the
 * acquirer. Replaces the per-attempt poll loop the pos-bos-wiring
 * prompt anticipated. Terminal correlates by `attemptId` (the same
 * ULID it sent at attempt-open time). Once replayed, the terminal
 * POSTs to `/sync/payments/results` with state=`reversed`; that flow
 * sets `completedAt` on the reversal row so it stops shipping in
 * subsequent deltas.
 */
exports.SyncReversalRecord = zod_1.z.object({
    id: zod_1.z.string(),
    attemptId: zod_1.z.string(),
    reasonCode: zod_1.z.string().min(1).max(64),
    reasonMessage: zod_1.z.string().nullable(),
    authoredAt: zod_1.z.string().datetime(),
});
exports.SyncReversalsResponse = deltaEnvelope(deltaItem(exports.SyncReversalRecord));
// ---------- Upload — Audit Log (Sprint 4 — implemented in 4.4) ----------
/**
 * Terminal-side audit entry. The terminal's local audit log mirrors
 * the BOS audit_log table; on sync these flow upward and are appended
 * to the BOS table verbatim. Idempotent on `clientUuid`.
 */
exports.SyncAuditLogRecord = zod_1.z.object({
    /** Terminal-side UUID. Server idempotency key. */
    clientUuid: zod_1.z.string().min(1).max(64),
    occurredAt: zod_1.z.string().datetime(),
    action: zod_1.z.string().min(1).max(120),
    entityType: zod_1.z.string().min(1).max(64),
    entityId: zod_1.z.string().nullable(),
    module: zod_1.z.string().min(1).max(64),
    /** Cashier id at time of action; null for terminal-only events. */
    actorCashierId: zod_1.z.string().nullable(),
    /** Free-form structured detail. */
    context: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.SyncAuditLogUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncAuditLogRecord).min(1).max(exports.SYNC_PAGE_SIZE_MAX),
});
exports.SyncAuditLogUploadResponse = exports.SyncBatchAck;
// ---------- Audit Log — fiscal journal voided by attendant reconcile ----------
/**
 * `action` of the audit record a terminal uploads when an attendant
 * reconcile voids a held fiscal journal row (committed → voided: the
 * fiscal device holds NO document, the checkout is released to re-pay or
 * abandon).
 *
 * This travels on `POST /sync/audit-log`, never `/sync/transactions`: the
 * sale did not complete, so it is an operational signal, not a financial
 * record, and nothing downstream may count it as a sale. BOS publishes the
 * per-terminal count as a metric (`reform_terminal_fiscal_voids_24h`) so a
 * till suffering repeated fiscal aborts stands out from a healthy one.
 *
 * Record shape: `entityType` = `fiscal_journal`, `entityId` = the voided
 * journal id, `module` = `fiscal`, `actorCashierId` = the attendant.
 */
exports.TERMINAL_FISCAL_JOURNAL_VOIDED_ACTION = 'terminal.fiscal_journal.voided';
/**
 * `context` of a {@link TERMINAL_FISCAL_JOURNAL_VOIDED_ACTION} record —
 * what an operator needs to diagnose the abort. Advisory: BOS stores the
 * context verbatim and does not reject a record over it (the upload is the
 * only copy of the evidence), but terminals should send this shape.
 */
exports.SyncFiscalJournalVoidedContext = zod_1.z.object({
    /** Shift the voided sale was rung in; null outside a shift. */
    shiftId: zod_1.z.string().nullable(),
    /** Basket the checkout was holding when the fiscal commit failed. */
    basketId: zod_1.z.string().nullable().optional(),
    /** Fiscal binding in use, e.g. `ua-prro`, `lt-vmi-sm`. */
    fiscalBindingId: zod_1.z.string().max(64).nullable().optional(),
    /** The failure that caused the hold. */
    failure: zod_1.z.object({
        code: zod_1.z.string().min(1).max(120),
        message: zod_1.z.string().max(2000).nullable().optional(),
    }),
    /** A captured (or possibly captured) card tender must be reversed. */
    cardReversalRequired: zod_1.z.boolean().optional(),
});
// ---------- Upload — Terminal device logs (RFL-178) ----------
exports.SyncTerminalLogLevel = zod_1.z.enum(['trace', 'debug', 'info', 'warn', 'error', 'fatal']);
/**
 * A single terminal device/app log line. The terminal buffers its own
 * application log locally (ring buffer) and flushes batches upward via
 * `POST /sync/terminal-logs` on the normal sync cadence. Idempotent on
 * `clientUuid` like the other upload domains. BOS retains entries for
 * a bounded window (default 30 days) and serves range downloads to
 * the admin UI — this is the support/QA path for "pull the logs off
 * POS-01 between 14:00 and 14:30 without walking to the store".
 */
exports.SyncTerminalLogRecord = zod_1.z.object({
    /** Terminal-side UUID. Server idempotency key. */
    clientUuid: zod_1.z.string().min(1).max(64),
    occurredAt: zod_1.z.string().datetime(),
    level: exports.SyncTerminalLogLevel,
    /** Logger / subsystem tag, e.g. `fiscal`, `sync`, `ui.returns`. */
    tag: zod_1.z.string().min(1).max(120).nullable(),
    message: zod_1.z.string().min(1).max(8192),
    /** Free-form structured detail. */
    context: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
exports.SyncTerminalLogsUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncTerminalLogRecord).min(1).max(exports.SYNC_PAGE_SIZE_MAX),
});
exports.SyncTerminalLogsUploadResponse = exports.SyncBatchAck;
// ---------- Kitchen station health (FN-92, ADR-0013) ----------
/**
 * What a kitchen station knows about its own order path, reported inside
 * telemetry `health.kitchen`. BOS is a mirror: nothing here is acted on,
 * it is what Fayno's IT sees per store (FN-58).
 */
exports.KitchenBrokerHealth = zod_1.z.object({
    configured: zod_1.z.boolean(),
    connected: zod_1.z.boolean(),
    consumerAlive: zod_1.z.boolean(),
    outboxDepth: zod_1.z.number().int().min(0),
    queueName: zod_1.z.string().max(200).nullable(),
    lastMessageAt: zod_1.z.string().datetime().nullable(),
    lastError: zod_1.z.string().max(512).nullable(),
});
exports.KitchenPrinterHealth = zod_1.z.object({
    configured: zod_1.z.boolean(),
    ready: zod_1.z.boolean(),
    model: zod_1.z.string().max(64).nullable(),
    target: zod_1.z.string().max(200).nullable(),
    lastError: zod_1.z.string().max(512).nullable(),
    lastPrintAt: zod_1.z.string().datetime().nullable(),
});
exports.KitchenTelemetryHealth = zod_1.z.object({
    broker: exports.KitchenBrokerHealth,
    printer: exports.KitchenPrinterHealth,
    /** Active (queued/preparing/ready) orders on the station right now. */
    activeOrders: zod_1.z.number().int().min(0).optional(),
});
// ---------- SecureScale weight copy on the lane (SSC-260, SSC-230) ----------
/**
 * The SecureScale weight copy an SCO lane holds, reported inside telemetry
 * `health.secureScaleCopy` (SSC-230 on the lane, SSC-260 here). BOS is a
 * mirror: it shows the facts to staff and nothing acts on them. There is no
 * threshold and no checkout downgrade.
 *
 * Each fact says who asserts it (`source`):
 * - `replica_bundle`: the version id, revision and build time come from the
 *   complete replica bundle that central built and signed.
 * - `lane_clock`: the lane recorded the time itself, on its own clock.
 *
 * Strict like the rest of the record: one malformed block rejects the whole
 * telemetry record (see `shared-scenarios/sync-telemetry/README.md`).
 */
exports.SecureScaleCopyVersionFact = zod_1.z.object({
    versionId: zod_1.z.string().min(1).max(64),
    revision: zod_1.z.number().int().min(0),
    /** When central built the version; null when the bundle did not say. */
    createdAt: zod_1.z.string().datetime().nullable(),
    source: zod_1.z.literal('replica_bundle'),
});
/** The version checks use now. */
exports.SecureScaleCopyCheckingFact = exports.SecureScaleCopyVersionFact.extend({
    /** `pinned`: pinned to the open sale. `active`: no sale open, the active version. */
    basis: zod_1.z.enum(['pinned', 'active']),
});
/** The last successful complete-list check, including an unchanged result. */
exports.SecureScaleCopyLastSyncFact = zod_1.z.object({
    /** Null when the lane never recorded one. */
    at: zod_1.z.string().datetime().nullable(),
    source: zod_1.z.literal('lane_clock'),
});
exports.SecureScaleCopyTelemetryHealth = zod_1.z.object({
    /** Null when the lane has no active weight data yet. */
    checking: exports.SecureScaleCopyCheckingFact.nullable(),
    /** A complete version downloaded and waiting for activation; not used for checks. */
    pending: exports.SecureScaleCopyVersionFact.nullable(),
    lastCompleteSync: exports.SecureScaleCopyLastSyncFact,
});
// ---------- Upload — Telemetry (Sprint 4 — implemented in 4.4) ----------
/**
 * Per-domain sync state from a terminal. Reported on its own cadence
 * (default 60s when idle, immediately after a sync round-trip). The
 * BOS sync-lag surface (4.5) reads the latest row per terminal and
 * computes red/yellow/green per TRS §11.8.
 */
exports.SyncTelemetryDomainState = zod_1.z.object({
    domain: zod_1.z.string().min(1),
    /** Last successful sync of this domain on the terminal. */
    lastSuccessAt: zod_1.z.string().datetime().nullable(),
    /** Last failure reason, if a recent failure exists. */
    lastFailureCode: zod_1.z.string().nullable(),
    /** Records currently in the local dead-letter queue for this domain. */
    deadLetterCount: zod_1.z.number().int().min(0),
    /**
     * Queue-state semantics version. Version 1 means `deadLetterCount` was
     * read from the durable outbox and survives a terminal restart. Absent on
     * legacy terminals, which used this field for an in-memory consecutive
     * failure counter; BOS retains a compatibility path during rollout.
     */
    queueStateVersion: zod_1.z.literal(1).optional(),
});
exports.SyncTelemetryRecord = zod_1.z.object({
    clientUuid: zod_1.z.string().min(1).max(64),
    reportedAt: zod_1.z.string().datetime(),
    /** Terminal app semver. */
    appVersion: zod_1.z.string().min(1),
    protocolVersion: zod_1.z.object({
        major: zod_1.z.number().int().min(0),
        minor: zod_1.z.number().int().min(0),
    }),
    /** Per-domain sync state — minimum: telemetry + audit-log + handshake. */
    domains: zod_1.z.array(exports.SyncTelemetryDomainState).min(1),
    /** Optional health metrics. */
    health: zod_1.z
        .object({
        uptimeSeconds: zod_1.z.number().int().min(0).optional(),
        memoryFreeMB: zod_1.z.number().int().min(0).optional(),
        diskFreeMB: zod_1.z.number().int().min(0).optional(),
        battery: zod_1.z
            .object({
            chargingPct: zod_1.z.number().int().min(0).max(100),
            plugged: zod_1.z.boolean(),
        })
            .optional(),
        /** Kitchen station only (FN-92). */
        kitchen: exports.KitchenTelemetryHealth.optional(),
        /**
         * Shift-boundary parameters (RL-267): the value each is operating under
         * now and any value held for the next shift boundary. Absent on
         * terminals that predate the report.
         */
        shiftBoundaryParams: zod_1.z.array(terminal_params_js_1.TerminalShiftBoundaryParamState).max(20).optional(),
        /**
         * SSC-260: the SecureScale weight copy an SCO lane holds. Absent on
         * lanes without SecureScale and on builds that predate SSC-230.
         */
        secureScaleCopy: exports.SecureScaleCopyTelemetryHealth.optional(),
    })
        .optional(),
    /**
     * RL-928: what the active pricing composition reports that Back Office may show,
     * e.g. `promotion.buy_x_get_y` (`TERMINAL_CAPABILITY_PROMOTION_BUY_X_GET_Y`).
     * The composition's reported capabilities, not an attestation. Older builds
     * and non-reporting compositions omit it: "not reported", never "none".
     * Informational only: it grants no authority and gates nothing BOS sends.
     */
    capabilities: zod_1.z.array(zod_1.z.string().min(1).max(128)).max(64).optional(),
});
/**
 * RL-928: the capability a till reports when its local pricing engine prices a
 * `buy_x_get_y` promotion (YUKI-406). BOS sends the kind to every till; one
 * without this capability drops the unknown kind and prices without it.
 */
exports.TERMINAL_CAPABILITY_PROMOTION_BUY_X_GET_Y = 'promotion.buy_x_get_y';
exports.SyncTelemetryUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncTelemetryRecord).min(1).max(100),
});
exports.SyncTelemetryUploadResponse = exports.SyncBatchAck;
// ---------- Upload — Transactions (Sprint 4 stub-501; full Sprint 6) ----------
/**
 * Transaction line carries the same fields the receipt-rendering
 * pipeline consumed in Sprint 3. The full transaction model + its
 * persistence land in Sprint 6 (payment state machine); this shape
 * is filed so the terminal can serialise sales offline against a
 * stable contract.
 */
const ExciseMark = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(128)
    // RL-439: retain existing printable ASCII 2D payloads, and also carry the
    // answered Cyrillic printed stamp without transliteration or data loss.
    .regex(/^(?:[\x21-\x7E]+|[A-ZА-ЯЁІЇЄҐ]{4}[0-9]{6})(?![\s\S])/, 'excise mark must be printable ASCII or a four-letter Latin/Cyrillic stamp followed by six digits');
exports.SyncTransactionLine = zod_1.z.object({
    /** Target-owned frozen facts; preserved only by the extensions capability route. */
    extensions: zod_1.z.record(zod_1.z.unknown()).optional(),
    /** Zero-based position on the immutable original sale for a refund.
     * Older tills omit it; SKU alone cannot identify repeated sale positions. */
    originalLineIndex: zod_1.z.number().int().min(0).max(9999).optional(),
    sku: zod_1.z.string().nullable(),
    name: zod_1.z.string().min(1),
    quantity: zod_1.z.number(),
    unitOfMeasure: zod_1.z.enum(['each', 'kg', 'g', 'l', 'ml']),
    lineTotalMinor: pricing_js_1.MoneyMinor,
    unitPriceMinor: pricing_js_1.MoneyMinor.nullable(),
    discountMinor: pricing_js_1.MoneyMinor.nullable(),
    discountType: zod_1.z.number().int().nullable().optional(),
    discountReason: zod_1.z.string().trim().min(1).max(254).nullable().optional(),
    /**
     * The part of `discountMinor` the line already carried BEFORE discount-booked
     * tender legs (bonuses, a redeemed gift card) were spread onto it — today the
     * cashier's manual reduction, and a promotion engine's once campaigns reach the
     * till (YUKI-133). The same figure the register's discount label is chosen from
     * (`FiscalDiscountSource.preTenderDiscountMinor`, YUKI-187).
     *
     * Sent because the spread MERGES into whatever the line held and clears the
     * line's `discountType` and `discountReason` as it does, so a line otherwise
     * arrives holding one number that is two reductions of different origin and the
     * origin of neither. This is where the cut is, and the GP export splits
     * `LineDiscounts` on it (YUKI-256).
     *
     * Absent from a till that predates the field, in which case the export falls
     * back to what the receipt can still prove. Never a claim about a line it does
     * not bound: a value above `discountMinor` is meaningless and is ignored.
     */
    preTenderDiscountMinor: pricing_js_1.MoneyMinor.nullable().optional(),
    /** Promotion-funded portion of the pre-tender cut. Zero proves none;
     * absence means an older till did not record the manual/promotion split. */
    promotionDiscountMinor: pricing_js_1.MoneyMinor.nullable().optional(),
    /**
     * The line's CashdeskDiscount (VL-49): everything that came off the line's
     * OLD amount — the store's old price (`t_bars.old_price`,
     * `VarusCatalogueBarcode.oldPriceMinor`) × quantity, or × weight for a
     * weighed line, rounded half-up to the minor unit as the line's own amount
     * is — down to what the line was paid ([lineTotalMinor]). So it is the old
     * price's reduction plus any discount the till gave on the line besides.
     * Minor units.
     *
     * It is how the store's old till filled its CRM product rows (Bohdan,
     * 2026-10-18, «як стара каса»): `Price` the old price, `Amount` the old
     * amount, `CashdeskDiscount` this, so `Amount − CashdeskDiscount` is what
     * the line was paid. The Link builds that row from [oldUnitPriceMinor],
     * [lineTotalMinor] and this, for the CRM's "set online" call and so for
     * `t_offline_processing.request_json`. The CRM accrues no bonuses on a
     * purchase that carries one above zero.
     *
     * Not a reduction of this line on top of the others: [lineTotalMinor] is
     * already what was paid, and `discountMinor` does not include the old
     * price's part.
     *
     * Absent — never zero — on a line without an old price above its price,
     * and from a till that predates the field. A consumer ignores a value that
     * is not above zero.
     */
    cashdeskDiscountMinor: pricing_js_1.MoneyMinor.optional(),
    /**
     * The store's old price per unit of sale (per piece, or per kilogram for a
     * weighed line) that [cashdeskDiscountMinor] is measured from (VL-49). Sent
     * with it and only with it; the Link sends it as the CRM product row's
     * `Price`. Minor units.
     */
    oldUnitPriceMinor: pricing_js_1.MoneyMinor.optional(),
    /**
     * A sell-by-weight line's net weight in grams, from the till's scale or the
     * scale label (VL-49). On such a line [unitPriceMinor] is the price per
     * kilogram and the line amount is `price × grams ÷ 1000`, rounded half-up to
     * the minor unit; [quantity] stays what the till has always uploaded there
     * (1), so a consumer that reads only [quantity] sees the line exactly as
     * before. The Link sends the CRM a weighed position by this weight, in
     * kilograms. Absent on every other line and from a till that predates the
     * field; a consumer ignores a value that is not a positive whole number.
     */
    weightGrams: zod_1.z.number().int().optional(),
    taxCategory: zod_1.z.string(),
    taxRatePercent: zod_1.z.number(),
    /**
     * Exact fiscal category transmitted to the register at SALE time (YUKI-165).
     *
     * Absent, never null: the terminal's serialiser omits the key entirely when
     * it has no value (`if (fiscalTaxCategory != null)`), so `.optional()`
     * without `.nullable()` is what the wire actually carries. Two review
     * branches each added this field and the merge kept both declarations — one
     * nullable, one bounded — which is a TS1117 duplicate key where the LAST
     * definition silently wins. Resolved to the bounded one because it matches
     * the serialiser; the nullable variant would have accepted a shape no
     * terminal sends while allowing an unbounded string.
     *
     * Optional for older terminals, which predate the snapshot. A return client
     * must NOT recompute a missing value under today's entity — an IE/LLC switch
     * between sale and return would refund at the wrong rate.
     */
    fiscalTaxCategory: zod_1.z.string().trim().min(1).max(64).optional(),
    scannedBarcode: zod_1.z.string().nullable().optional(),
    discountsProhibited: zod_1.z.boolean().optional(),
    returnProhibited: zod_1.z.boolean().optional(),
    giftCardNumber: zod_1.z.string().nullable().optional(),
    /**
     * The excise marks (акцизні марки) scanned against this line, in scan order
     * (RL-469). The store-system export writes them as the line's `mark_code`,
     * which it had to leave empty while the upload carried none.
     *
     * A list because one line may hold several bottles and each bottle carries
     * its own mark; today's tills hold at most one per line and send a list of
     * one. Absent — never an empty array — on a line with no mark and from a till
     * that predates the field, so both read alike.
     *
     * A mark is a printed identifier, not a payment credential. The charset is
     * printable ASCII without spaces, which covers the ten-character `[A-Z0-9]`
     * stamp and the longer code a scanned 2D mark yields, and keeps control
     * characters and markup out of the export file.
     */
    exciseMarks: zod_1.z.array(ExciseMark).min(1).max(256).optional(),
    /**
     * FN-225: the line was sold WITHOUT its excise stamp. The item's stamp policy
     * was `optional` (FN-220) and a cashier holding `till.excise-mark.skip` — or a
     * supervisor approving for one — skipped the stamp window. The till journals
     * the same skip on the audit log (`terminal.excise_mark.skipped`); this is
     * the fact on the receipt line itself.
     *
     * Absent — the till omits it when false — on every other line and from a
     * till that predates FN-220. A `false` that does arrive is kept as sent.
     *
     * Such a line carries no [exciseMarks]: the till clears them when it skips.
     * A line that nevertheless carries both is contradictory, and is accepted
     * and stored as given, not refused — for the reason MICRO-43's
     * [parentLineNo] is not cross-checked: a refine would refuse the till's
     * whole upload batch over one odd line and stall its queue on a sale the
     * register has already printed. Both keys are kept, so the contradiction
     * stays visible to whoever reads the line.
     */
    exciseStampSkipped: zod_1.z.boolean().optional(),
    /**
     * MICRO-43: what the line is. `deposit` is the container deposit the till
     * added for the line [parentLineNo] names; it is outside sales turnover and
     * the GP export writes it as that line's child (`ParentLineNumber`).
     * Absent — from a till that predates the field — or `sale`: an ordinary line.
     */
    lineRole: zod_1.z.enum(['sale', 'deposit']).optional(),
    /**
     * MICRO-43: the 1-based position in this transaction's `lines` of the line a
     * deposit belongs to (GP's `ParentLineNumber`). Sent with `lineRole:
     * deposit` only.
     *
     * Not cross-checked here on purpose: a refine would refuse the till's whole
     * upload batch over one odd link and stall its queue. A consumer treats a
     * deposit whose parent is missing, out of range or itself a deposit as an
     * unlinked deposit line.
     */
    parentLineNo: zod_1.z.number().int().min(1).max(9999).optional(),
});
exports.SyncReturnReason = zod_1.z
    .object({
    key1: zod_1.z.string().min(1).max(50),
    key2: zod_1.z.string().min(1).max(50).nullable(),
    key3: zod_1.z.string().min(1).max(50).nullable(),
    label: zod_1.z.string().min(1).max(254),
})
    .strict();
/**
 * One captured tender leg of a finalised receipt (YUKI-257).
 *
 * `tenderKind` says only what a receipt was settled WITH, and on a split tender
 * it says `split:card=500;cash=400` — a string no consumer can decompose back
 * into money it dare book. That is why the GP export sent no `Payments` array at
 * all for a mixed receipt. These legs are the decomposition.
 *
 * `cardNumber` and `authorizationCode` are the acquirer's own answer for a card
 * leg — the masked PAN and the approval code from the BPOS 2 reply. The PAN
 * arrives masked from the terminal and is never unmasked on the way here. The
 * schema independently caps visible digits at first-six + last-four, so a
 * faulty or compromised terminal cannot freeze a full PAN in BOS.
 *
 * `rrn` and `paymentTerminalId` identify the card transaction at the acquirer
 * (RL-469). Optional like the rest: an older till, a cash leg and an adapter
 * that reports neither all omit them.
 *
 * `discountClassified` marks a leg that REDUCES what is owed instead of settling
 * it — loyalty points and, on the fiscal document, gift certificates. Those
 * amounts are already inside the receipt's discounts. GP has one explicit
 * exception: YUKI-233 requires a redeemed gift card as payment type 18.
 *
 * `giftCardNumber` is the number of the gift card a `giftCard` leg redeemed
 * (YUKI-306), which GP's export names on the lines it reduced or on the type-18
 * payment row. Deliberately NOT `cardNumber`: that field is a bank PAN and is
 * capped at ten visible digits, which a voucher number printed on a plastic
 * card may exceed — a real number refused there would reject the whole receipt.
 * A gift card number is not a payment credential; it is the certificate's own
 * printed identity, already on the customer's paper receipt.
 */
const MaskedCardNumber = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(64)
    .regex(/^[\x20-\x7E•]+$/, 'cardNumber may contain ASCII mask text or the bullet mask glyph only')
    .refine((value) => value.replace(/\D/g, '').length <= 10, {
    message: 'cardNumber must expose at most the first six and last four PAN digits',
});
/**
 * An acquirer-issued reference on a card leg: the retrieval reference number
 * (`rrn`, ISO 8583 field 37 — twelve characters on every acquirer seen so far)
 * or the payment terminal's own id (`paymentTerminalId`, field 41 — eight).
 * The store-system export needs both to reconcile a card row against the bank
 * statement (RL-469).
 *
 * Neither is a card number, and the cap on digits is what keeps a mis-mapped
 * PAN from being frozen in BOS under a different name: a PAN has at least
 * thirteen digits, a reference at most twelve. The same reasoning as
 * `MaskedCardNumber`, placed where a vendor's field-name mix-up would land.
 */
exports.CardTransactionReference = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(32)
    .regex(/^[A-Za-z0-9._-]+$/, 'card reference may contain ASCII letters, digits, ".", "_" and "-" only')
    .refine((value) => value.replace(/\D/g, '').length <= 12, {
    message: 'card reference must not carry more than twelve digits',
});
// The digit re-test is not redundant. A failed `.regex()` check leaves zod's
// status dirty rather than aborted, so this refinement still runs on a value
// like `'abc'`; an unguarded `BigInt()` would throw straight out of
// `safeParse` and turn a malformed record into a 500 instead of a rejection ack.
const PositiveMoneyMinor = pricing_js_1.MoneyMinor.refine((value) => /^-?\d+$/.test(value) && BigInt(value) > 0n, { message: 'payment amountMinor must be positive' });
exports.SyncTransactionPayment = zod_1.z
    .object({
    extensions: zod_1.z
        .object({
        'snx.host': zod_1.z
            .object({
            stan: exports.CardTransactionReference.optional(),
            merchantId: exports.CardTransactionReference.optional(),
            cardScheme: zod_1.z.string().trim().min(1).max(64).optional(),
            maskedPAN: MaskedCardNumber.optional(),
            hostTimestamp: zod_1.z.string().datetime().optional(),
            /**
             * SNX-1124: the EPS document number the card leg was authorised
             * under — the key the till's later settlement report (settled /
             * voided) and its pending-authorisation snapshot use, so the back
             * office can show how this leg ended. Never a card number.
             */
            attemptId: zod_1.z
                .string()
                .regex(/^[A-Za-z0-9._:-]{1,64}$/)
                .refine((v) => !/\d{13,}/.test(v), {
                message: 'attempt id must not carry a card number',
            })
                .optional(),
            /** The authorisation result when the receipt was frozen; settlement is reported later. */
            finalStatus: zod_1.z.enum(['approved', 'declined', 'unknown']),
        })
            .strict()
            .optional(),
    })
        .strict()
        .optional(),
    method: zod_1.z.string().trim().min(1).max(64),
    amountMinor: PositiveMoneyMinor,
    cardNumber: MaskedCardNumber.optional(),
    authorizationCode: zod_1.z.string().trim().min(1).max(64).optional(),
    discountClassified: zod_1.z.boolean().optional(),
    giftCardNumber: zod_1.z.string().trim().min(1).max(64).optional(),
    /** Retrieval reference number of a card leg, as the acquirer reported it (RL-469). */
    rrn: exports.CardTransactionReference.optional(),
    /** Id of the payment terminal (PIN pad) that took a card leg (RL-469). */
    paymentTerminalId: exports.CardTransactionReference.optional(),
})
    .strict();
/**
 * Who authorised a transaction for the cashier who rang it up (RL-513): the
 * supervisor whose override let an ordinary cashier issue a refund, or the
 * second cashier who confirmed it. `cashierId` beside it stays the operator.
 *
 * `employeeCode` is the identifier the approval audit event already carries,
 * so the two can be joined; `cashierId` is the approver's cashier id, absent
 * when the till could not name one. Not `.strict()`: this block describes a
 * refund that has already been paid out, and a later till adding a key here
 * must not get that refund refused by an older Back Office.
 */
exports.SyncTransactionApprover = zod_1.z.object({
    cashierId: zod_1.z.string().min(1).max(64).nullable().optional(),
    employeeCode: zod_1.z.string().trim().min(1).max(64),
});
/**
 * RL-573: whether the store's CRM confirmed the loyalty card on a receipt at
 * the till — `verified` (found online) or `unverified` (taken as presented
 * while the Link or the CRM could not be reached).
 */
exports.LoyaltyCardVerification = zod_1.z.enum(['verified', 'unverified']);
/**
 * YUKI-454: how the till identified the loyalty customer on a sale. No personal
 * data, only the method: by phone number (a customer enrolled in the till's card
 * dialog counts as PHONE), by a scanned card, by a card number typed in, an
 * attempt that failed, or none. Exported to GP as `AuthorizeMethod`.
 */
exports.LoyaltyIdentification = zod_1.z.enum([
    'PHONE',
    'CARD_SCAN',
    'CARD_MANUAL',
    'FAILED',
    'NONE',
]);
/**
 * The method a sale's raw `loyaltyIdentification` names, or null when it names
 * none of the five. The upload never refuses a sale over this field: it carries
 * fiscalised receipts, and a newer till's new value or a typo must not stop one
 * from syncing (Platform, 2026-10-29). Unknown means no method.
 */
function loyaltyIdentificationOf(raw) {
    const parsed = exports.LoyaltyIdentification.safeParse(raw);
    return parsed.success ? parsed.data : null;
}
/**
 * VL-26's store CRM voucher evidence on a sale: the voucher as scanned
 * (`code`), the till basket it was reserved under (`basketId`) and the CRM's
 * discount per receipt position (`lines`, 1-based, minor units).
 *
 * VL-384 Option A: VL-26's voucher routes, service and client are NOT part of
 * this cut, and nothing here consumes a voucher. The field is kept, with
 * VL-26's exact shape, as a bounded carrier of unsupported evidence: a record
 * that carries it must never be read as an ordinary sale with the voucher
 * stripped (the Link refuses or holds it; an online order's sale refuses it
 * as `osr_voucher_conflict`).
 */
exports.SyncCrmVoucher = zod_1.z
    .object({
    code: zod_1.z.string().regex(/^[A-Za-z0-9_-]{3,64}$/),
    basketId: zod_1.z.string().regex(/^[A-Za-z0-9_-]{8,64}$/),
    lines: zod_1.z
        .array(zod_1.z
        .object({
        position: zod_1.z.number().int().min(1).max(9999),
        discountMinor: pricing_js_1.MoneyMinor,
    })
        .strict())
        .max(500),
})
    .strict();
/**
 * VL-387 / VL-384: the record's `extensions` key of an online order (OSR) the
 * till sold. Written by the till's Varus POS; read by the Link's CRM receipt
 * outbox and by the Masterkasa export.
 */
exports.SYNC_OSR_EXTENSION = 'rl.osr';
const OsrMinor = zod_1.z.number().int().min(0).max(Number.MAX_SAFE_INTEGER);
/**
 * `extensions['rl.osr']` on a sale record:
 *
 * - `channelCode` — the receipt's sales channel, 1 for an online order
 *   (`t_receipts.channel_code`, the CRM's `PurchaseChannelCode`);
 * - `orderNumber` — the OSR order;
 * - `preprocessingId` — the CRM purchase key the website opened the order's
 *   purchase under (`paymentData.preprocessingId`). The till never changes it:
 *   the Link's "set online" and commit for the receipt use it as is;
 * - `writtenOffBonusesMinor` — the bonuses the customer redeemed on the
 *   website (`paymentData.writtenOffBonuses`), sent as `BonusesToWriteOff`;
 * - `bonusesPaidMinor` — what the receipt records as redeemed (the CRM's
 *   `BonusesPaidAmount` before payment, never above `writtenOffBonusesMinor`).
 *   The till booked it as a `loyalty` leg marked `discountClassified` and
 *   spread it over the lines' `discountMinor` (above `preTenderDiscountMinor`);
 * - `loyaltyConfirmed` — false when the till paid the order as opened while
 *   the loyalty service did not answer (VL-386).
 * - `loyaltyPostProcessing`, `offlineProcessing` — the store retry records
 *   (VL-385 / VL-386); read by [syncOsrPostProcessingOf], not here, so a bad
 *   retry record never makes the order itself unreadable.
 *
 * Only version 1 is read; another version, like any shape that does not fit,
 * is `invalid` to [syncOsrOrderOf] — never read as an ordinary sale, because
 * the website has already reserved bonuses under the order's key.
 */
exports.SyncOsrOrder = zod_1.z
    .object({
    v: zod_1.z.literal(1),
    channelCode: zod_1.z.number().int().min(0).max(99),
    orderNumber: zod_1.z.string().trim().min(1).max(64),
    preprocessingId: zod_1.z.string().uuid().optional(),
    writtenOffBonusesMinor: OsrMinor,
    bonusesPaidMinor: OsrMinor.optional(),
    loyaltyConfirmed: zod_1.z.boolean().optional(),
})
    .passthrough()
    .refine((order) => (order.bonusesPaidMinor ?? 0) <= order.writtenOffBonusesMinor, 'bonusesPaidMinor is above writtenOffBonusesMinor')
    .refine((order) => order.writtenOffBonusesMinor === 0 || order.preprocessingId !== undefined, 'redeemed bonuses without the purchase key they were redeemed under');
/** The online order a record's `extensions` names (VL-384), if any. */
function syncOsrOrderOf(extensions) {
    if (extensions === null || typeof extensions !== 'object' || Array.isArray(extensions)) {
        return { kind: 'absent' };
    }
    const raw = extensions[exports.SYNC_OSR_EXTENSION];
    if (raw === undefined || raw === null)
        return { kind: 'absent' };
    const parsed = exports.SyncOsrOrder.safeParse(raw);
    return parsed.success ? { kind: 'order', order: parsed.data } : { kind: 'invalid' };
}
/**
 * VL-385 / VL-386: the `t_offline_processing` action codes a till leaves on an
 * online-order sale for the store's own `offline_processing` service:
 * 8 — OSR did not get the fiscalisation status; 11 — the order's bonuses were
 * redeemed on the website and the sale was paid while the loyalty service did
 * not answer, so its "set online" and commit are the service's to send.
 */
exports.SYNC_OSR_OFFLINE_ACTION_FISCAL_STATUS = 8;
exports.SYNC_OSR_OFFLINE_ACTION_BONUSES = 11;
/**
 * VL-386: `rl.osr.loyaltyPostProcessing` — who sends the sale's "set online"
 * and commit. Absent: the Link's CRM receipt outbox, as before. This value:
 * the store's `offline_processing` service (from the action 11 record), and
 * the Link must never send them itself.
 */
exports.SYNC_OSR_LOYALTY_POST_PROCESSING_OFFLINE = 'offline_processing';
/**
 * `origin.binding` of a till's store retry record (terminals VL-385 round 2):
 * `original` — the binding captured with the order before fiscalisation;
 * `missing` / `unreadable` — none could be read (the till's `noBinding`), so
 * the record names only the original till it could still read.
 */
exports.SYNC_OSR_ORIGIN_BINDINGS = ['original', 'missing', 'unreadable'];
/**
 * One entry of `rl.osr.offlineProcessing`: a `t_offline_processing` row the
 * till asks the store Link to write, in the current till's own format.
 *
 * - `kassaNumber` / `receiptNumber` — the till's own view, for reference: the
 *   row is written with the register and receipt number the store export gave
 *   the receipt in `t_receipts`;
 * - `operationAt` — the instant (UTC) the row is about; written as the store's
 *   local wall time;
 * - `preprocessingId` — action 11 only: the order's CRM purchase key;
 * - `requestJson` — the row's `request_json`, written verbatim.
 *
 * VL-385 / VL-386 review (the ORIGINAL binding): since terminals round 2 an
 * entry also carries
 * - `attemptId` — the till's stable id of this one attempt (one per receipt
 *   and action): the Link's idempotency key;
 * - `clientUuid` — the receipt the entry belongs to (= the record's);
 * - `origin` — what the receipt was rung under, as far as the till could
 *   read it: `{cashBoxId, baseUrl, storeId, binding}` with `binding` one of
 *   `original` | `missing` | `unreadable` ([SYNC_OSR_ORIGIN_BINDINGS]).
 * With these, `kassaNumber` / `receiptNumber` are the row's register and
 * receipt number (the till's own, never the store export's). They are read
 * leniently here and judged by `osrPostProcessingOf` (connectors): an entry
 * without them is held for a person, never written under a guessed binding.
 */
exports.SyncOsrOfflineEntry = zod_1.z
    .object({
    action: zod_1.z.union([
        zod_1.z.literal(exports.SYNC_OSR_OFFLINE_ACTION_FISCAL_STATUS),
        zod_1.z.literal(exports.SYNC_OSR_OFFLINE_ACTION_BONUSES),
    ]),
    kassaNumber: zod_1.z.number().int().nullable().optional(),
    receiptNumber: zod_1.z
        .union([zod_1.z.string().max(64), zod_1.z.number().int()])
        .nullable()
        .optional(),
    operationAt: zod_1.z.string().datetime(),
    preprocessingId: zod_1.z.string().uuid().optional(),
    requestJson: zod_1.z.string().refine((value) => {
        const length = value.trim().length;
        return length >= 2 && length <= 262_144;
    }, 'request JSON must contain 2 to 262144 characters after trimming'),
    attemptId: zod_1.z.unknown().optional(),
    clientUuid: zod_1.z.unknown().optional(),
    origin: zod_1.z.unknown().optional(),
})
    .passthrough()
    .refine((entry) => entry.action !== exports.SYNC_OSR_OFFLINE_ACTION_BONUSES || entry.preprocessingId !== undefined, 'an action 11 record without the purchase key it is about');
/**
 * The post-processing facts of a record's `extensions['rl.osr']`. The
 * `offlineProcessing` carrier is a list since VL-386; a till with only
 * VL-385 sends one object. Both are read; anything else is no entries.
 */
function syncOsrPostProcessingOf(extensions) {
    const none = {
        marker: null,
        entries: [],
        invalidEntries: 0,
        bonusesRecordClaims: 0,
        statusRecordClaims: 0,
    };
    if (extensions === null || typeof extensions !== 'object' || Array.isArray(extensions)) {
        return none;
    }
    const osr = extensions[exports.SYNC_OSR_EXTENSION];
    if (osr === null || typeof osr !== 'object' || Array.isArray(osr))
        return none;
    const block = osr;
    const marker = block['loyaltyPostProcessing'] ?? null;
    const carrier = block['offlineProcessing'];
    const raw = carrier === undefined || carrier === null ? [] : Array.isArray(carrier) ? carrier : [carrier];
    const entries = [];
    let invalidEntries = 0;
    let bonusesRecordClaims = 0;
    let statusRecordClaims = 0;
    for (const item of raw) {
        const action = item !== null && typeof item === 'object'
            ? item['action']
            : undefined;
        if (action === exports.SYNC_OSR_OFFLINE_ACTION_BONUSES)
            bonusesRecordClaims += 1;
        if (action === exports.SYNC_OSR_OFFLINE_ACTION_FISCAL_STATUS)
            statusRecordClaims += 1;
        const parsed = exports.SyncOsrOfflineEntry.safeParse(item);
        if (parsed.success)
            entries.push(parsed.data);
        else
            invalidEntries += 1;
    }
    return { marker, entries, invalidEntries, bonusesRecordClaims, statusRecordClaims };
}
exports.SyncTransactionRecord = zod_1.z.object({
    clientUuid: zod_1.z.string().min(1).max(64),
    /** Canonical BOS store id frozen at transaction start; optional for older terminals. */
    salesStoreId: zod_1.z.string().min(1).max(128).optional(),
    receiptType: zod_1.z.enum(['sale', 'refund', 'void', 'parked', 'x_report', 'z_report', 'copy']),
    /** RL-582: opaque sale-start capability; older BOS strips this optional field. */
    receiptLinkToken: zod_1.z
        .string()
        .regex(/^[0-7][0-9A-HJKMNP-TV-Z]{25}$/)
        .optional(),
    finalisedAt: zod_1.z.string().datetime(),
    cashierId: zod_1.z.string().nullable(),
    /**
     * The terminal-side ULID of the open shift the receipt was rung
     * under (the same key the terminal uploaded via
     * /sync/shift-events). BOS resolves this to the server-assigned
     * `shifts.id` via the `(terminalId, clientUuid)` UNIQUE before
     * inserting the receipt — matches the pattern used by
     * CashMovementPayload + ShiftTransition/ShiftClosePayload.
     * Pre-rename (≤ commit 8be6424) this field was named `shiftId`
     * and was treated as the BOS server cuid, which forced terminals
     * to round-trip through the shift-open ack to learn an id they
     * already knew under a different name. See H-177.
     */
    shiftClientUuid: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.SyncTransactionLine).min(1),
    subtotalMinor: pricing_js_1.MoneyMinor,
    totalDiscountMinor: pricing_js_1.MoneyMinor.nullable(),
    totalMinor: pricing_js_1.MoneyMinor,
    /** Fiscal block snapshot — adapter-specific payload, opaque to BOS in Sprint 4. */
    fiscal: zod_1.z
        .object({
        receiptNumber: zod_1.z.string().min(1),
        fiscalNumber: zod_1.z.string().min(1),
        timestampFormatted: zod_1.z.string().min(1),
        signature: zod_1.z.string().nullable(),
        qrPayload: zod_1.z.string().nullable(),
        registrarId: zod_1.z.string().optional(),
        testDocument: zod_1.z.boolean().optional(),
    })
        .passthrough()
        .nullable(),
    /** Country pack id + version snapshot at sale time (TRS §24.6). */
    countryPackId: zod_1.z.string(),
    countryPackVersion: zod_1.z.string(),
    /**
     * For refund records, the receipt being returned against. Sprint
     * 10 adds this: refund uploads MUST carry `originalReceiptId` so
     * BOS can drive the receipt-lifecycle state machine + insert
     * `return_line_allocations` (TRS §22).
     */
    originalReceiptId: zod_1.z.string().nullable().optional(),
    /** Complete GP Key1/Key2/Key3 reason path selected for a refund (YUKI-6). */
    returnReason: exports.SyncReturnReason.nullable().optional(),
    /** Cross-lane original-sale snapshot used by YUKI-28 easy return. */
    currency: zod_1.z.string().min(3).max(3).optional(),
    tenderKind: zod_1.z.string().min(1).max(254).optional(),
    /**
     * The legs `tenderKind` summarises (YUKI-257). Absent from a till that
     * predates the field — which is why the GP export keeps its `tenderKind`
     * path for those receipts rather than treating an absent array as "no
     * payment".
     */
    payments: zod_1.z.array(exports.SyncTransactionPayment).max(32).optional(),
    tenderedMinor: pricing_js_1.MoneyMinor.optional(),
    changeMinor: pricing_js_1.MoneyMinor.optional(),
    /**
     * Cash rounding the register booked, as paid minus owed — the sign printed
     * beside «Заокруглення», so 5.32 settled as 5.00 is `"-32"` (YUKI-232).
     * A sale's `totalMinor` is already the rounded figure while its lines sum to
     * what was owed; this is the difference. Absent when nothing was rounded.
     */
    roundingMinor: pricing_js_1.MoneyMinor.optional(),
    loyaltyCardId: zod_1.z.string().min(1).max(128).optional(),
    loyaltyCardNumber: zod_1.z.string().min(1).max(128).optional(),
    /**
     * RL-573: whether the store's CRM confirmed `loyaltyCardNumber` at the till.
     * Sent only by a till whose store resolves loyalty through its Link
     * (`loyaltySource = link`): `verified` when the CRM found the card online
     * (`loyaltyCardId` is then the CRM's account identifier), `unverified` when
     * the Link or the CRM could not be reached and the card was taken as
     * presented, for the CRM to validate later from the receipt. Absent
     * otherwise, which is also what a till that predates the field sends.
     */
    loyaltyCardVerification: exports.LoyaltyCardVerification.optional(),
    /**
     * YUKI-454: how the loyalty customer was identified ([LoyaltyIdentification]).
     * Absent from a till that predates the field. Kept as sent and read through
     * [loyaltyIdentificationOf]: a value outside the five never refuses the sale,
     * it reads as no method.
     */
    loyaltyIdentification: zod_1.z.unknown().optional(),
    /** VL-26's voucher evidence: unsupported here, never consumed ([SyncCrmVoucher]). */
    crmVoucher: exports.SyncCrmVoucher.optional(),
    returnLoyaltyContext: zod_1.z.record(zod_1.z.unknown()).optional(),
    receiptDocument: zod_1.z.record(zod_1.z.unknown()).optional(),
    extensions: zod_1.z.record(zod_1.z.unknown()).optional(),
    /**
     * The approver, when someone other than `cashierId` authorised this
     * transaction (RL-513). Optional both ways: a till that predates the field
     * sends none, and a Back Office that predates it strips it, as it does any
     * key it does not know.
     */
    approver: exports.SyncTransactionApprover.optional(),
});
exports.SyncTransactionsUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncTransactionRecord).min(1).max(exports.SYNC_PAGE_SIZE_MAX),
});
exports.SyncTransactionsUploadResponse = exports.SyncBatchAck;
// ---------- Upload — Fiscal journal (RL-540) ----------
/**
 * The fiscal documents a register issues that are NOT receipts (RL-540):
 * Z and X reports, service cash-in / cash-out (службове внесення /
 * вилучення), and the markers of the register's offline sessions.
 *
 * **Why not `/sync/transactions`.** `SyncTransactionRecord` requires at least
 * one line, its `receiptType` has no cash in / cash out, and a Back Office
 * that predates this answers a record it cannot parse with a PERMANENT
 * `VALIDATION_FAILED` — the till dead-letters it and the document is lost.
 * A receipt row is also the wrong home: `lines`, totals, lifecycle state and
 * every receipt consumer (GP export, dashboards, returns) would have to learn
 * to skip a document that sold nothing. So these travel on their own domain,
 * `sync.fiscal-journal` (`POST /sync/fiscal-journal`), and a till uploads them
 * only once Back Office advertises that capability as `ready` in the
 * handshake. Until then the till holds them in its outbox — nothing is lost
 * and nothing is refused.
 *
 * **Identity and order.** `clientUuid` is derived by the till from the
 * document's own identity (register, type, numbers), so re-observing the
 * same document — a retried call, a restart — yields the same key and Back
 * Office dedups on `(terminalId, clientUuid)` as for every upload. Records
 * are uploaded in the order the till recorded them, which is the order the
 * register issued them. The fiscal order within one register is
 * `registrarId`, then `fiscal.receiptNumber` where present, then
 * `occurredAt`.
 *
 * **Receipts are not repeated here.** Sales, refunds, voids and copies stay on
 * `/sync/transactions` with their own `fiscal` block; RL-553 adds the register
 * (`registrarId`) and the offline flag there. The cash movement itself (the
 * drawer operation) stays on `/sync/shift-events`; RL-553 puts the service
 * document's numbers on it, which is what joins a `cash_in` / `cash_out`
 * record here to its movement: `(registrarId, fiscal.fiscalNumber)`.
 */
exports.SyncFiscalJournalDocumentType = zod_1.z.enum([
    'x_report',
    'z_report',
    'cash_in',
    'cash_out',
    'offline_session_open',
    'offline_session_close',
]);
/**
 * The document's fiscal identity, in the shape of `SyncTransactionRecord.fiscal`
 * so one renderer serves both — but every field is nullable, because not every
 * journal document has every number: an X report is non-fiscal and has none,
 * and the library reports no local number for a Z.
 */
exports.SyncFiscalJournalFiscal = zod_1.z.object({
    /** The register's local document number (UA: `ORDERNUM`), as printed. */
    receiptNumber: zod_1.z.string().trim().min(1).max(64).nullable(),
    /**
     * The tax authority's number for the document (UA: `ORDERTAXNUM`), or the
     * offline-format number `<session>.<n>.<control>` for a document issued in
     * an offline session.
     */
    fiscalNumber: zod_1.z.string().trim().min(1).max(128).nullable(),
    /** The register's own document time, as it reports it (UA: `yyyyMMddHHmmss`, local time). */
    timestampFormatted: zod_1.z.string().trim().min(1).max(64).nullable(),
    signature: zod_1.z.string().max(1024).nullable(),
    /** The tax authority's verification URL printed as a QR, when the register composes one. */
    qrPayload: zod_1.z.string().max(4096).nullable(),
});
/**
 * The register's offline session, as its fiscal library reports it.
 *
 * On `offline_session_open` / `offline_session_close` this IS the record; on
 * any other document it says which offline session the document was issued
 * in (absent / null when it was issued online or the till could not tell).
 *
 * The markers are the till's observation of the library's offline state, not
 * the register's own session-open / session-close documents: the UA library
 * files those (DOCTYPE 102 / 103) without reporting them, and they consume
 * local numbers — which is why a gap of numbers next to an offline session is
 * expected, and why the markers are uploaded at all.
 */
exports.SyncFiscalJournalOfflineSession = zod_1.z.object({
    /** The offline session id the tax authority issued (UA: `Offline/Session`). */
    id: zod_1.z.string().trim().min(1).max(64).nullable(),
    /** When the session began, verbatim as the library recorded it (register local time). */
    startedAt: zod_1.z.string().trim().min(1).max(64).nullable(),
    /** Documents the library had issued in the session when it was last observed. */
    documents: zod_1.z.number().int().min(0).nullable(),
});
const DecimalPercent = zod_1.z
    .string()
    .regex(/^\d{1,3}(\.\d{1,4})?$/, 'a percentage as a decimal string, e.g. "20.00"');
/** One labelled amount of a Z report, verbatim from the register's printout. */
exports.SyncFiscalJournalZLine = zod_1.z.object({
    /** The heading the line was printed under, when there was one. */
    section: zod_1.z.string().trim().min(1).max(128).nullable(),
    label: zod_1.z.string().trim().min(1).max(128),
    amountMinor: pricing_js_1.MoneyMinor,
});
/** A Z total for one tax group. */
exports.SyncFiscalJournalZTaxGroup = zod_1.z.object({
    /** `sale` (реалізація) or `refund` (повернення). */
    direction: zod_1.z.enum(['sale', 'refund']),
    /** The register's tax-group letter, e.g. `А`. */
    taxGroup: zod_1.z.string().trim().min(1).max(16),
    ratePercent: DecimalPercent.nullable(),
    /** The line exactly as the register labelled it, so its meaning is never guessed. */
    label: zod_1.z.string().trim().min(1).max(128),
    amountMinor: pricing_js_1.MoneyMinor,
});
/** A Z total for one payment type. */
exports.SyncFiscalJournalZPayment = zod_1.z.object({
    direction: zod_1.z.enum(['sale', 'refund']),
    /** `cash` / `card` when the label says so unambiguously; null otherwise. */
    method: zod_1.z.enum(['cash', 'card']).nullable(),
    label: zod_1.z.string().trim().min(1).max(128),
    amountMinor: pricing_js_1.MoneyMinor,
});
/**
 * Z totals as structured fields (RL-540).
 *
 * `source: 'register_text'` — read off the register's own printed Z (the
 * figures the tax authority holds), never recomputed from the till's
 * receipts. `lines` carries every labelled amount the register printed, in
 * order; the named fields are the ones the till recognised with certainty.
 * A field the till could not recognise is null (or an empty list) — never 0.
 * Back Office keeps `documentText` too, so a later, better reading can be
 * re-derived from the same document.
 */
exports.SyncFiscalJournalZTotals = zod_1.z.object({
    source: zod_1.z.enum(['register_text']),
    currency: zod_1.z.string().length(3).nullable(),
    cashBalanceMinor: pricing_js_1.MoneyMinor.nullable(),
    cashInMinor: pricing_js_1.MoneyMinor.nullable(),
    cashOutMinor: pricing_js_1.MoneyMinor.nullable(),
    byTaxGroup: zod_1.z.array(exports.SyncFiscalJournalZTaxGroup).max(64),
    byPayment: zod_1.z.array(exports.SyncFiscalJournalZPayment).max(64),
    lines: zod_1.z.array(exports.SyncFiscalJournalZLine).max(512),
});
/** Upper bound on a document's printed text — a long Z is a few KB. */
exports.SYNC_FISCAL_JOURNAL_TEXT_MAX = 65536;
const SyncFiscalJournalRecordBase = zod_1.z.object({
    clientUuid: zod_1.z.string().min(1).max(64),
    documentType: exports.SyncFiscalJournalDocumentType,
    /** When the till recorded the document (UTC, till clock). */
    occurredAt: zod_1.z.string().datetime(),
    /**
     * The register that issued the document (UA: ФН ПРРО). Null only when
     * neither the library nor the printed document named it.
     */
    registrarId: zod_1.z.string().trim().min(1).max(64).nullable(),
    /** The terminal-side id of the till shift open at the time, as on `SyncTransactionRecord`. */
    shiftClientUuid: zod_1.z.string().min(1).max(64).nullable(),
    cashierId: zod_1.z.string().min(1).max(64).nullable(),
    /** The register's shift ordinal (UA: `<Day>`, printed as `Z-ЗВІТ <n>`). */
    shiftNumber: zod_1.z.string().trim().min(1).max(16).nullable(),
    fiscal: exports.SyncFiscalJournalFiscal.nullable(),
    /**
     * Whether the document reached the tax authority when it was issued:
     * `true` online, `false` issued in an offline session, `null` not known /
     * not applicable (an X report, a marker). Taken from the library's own flag;
     * for a Z, which the library does not flag, from its fiscal number — an
     * offline number has the `<session>.<n>.<control>` form.
     */
    online: zod_1.z.boolean().nullable(),
    offlineSession: exports.SyncFiscalJournalOfflineSession.nullable(),
    /** The register is in test mode; the document is not fiscal. */
    testDocument: zod_1.z.boolean(),
    /** Service cash in / out: the amount, positive. Null on every other type. */
    amountMinor: pricing_js_1.MoneyMinor.nullable(),
    currency: zod_1.z.string().length(3).nullable(),
    /**
     * The register's own printed text of the document, verbatim — including its
     * print markup (ESC sequences), as `register_document` on a receipt. Null for
     * a marker and when the library returned no capture.
     */
    documentText: zod_1.z.string().max(exports.SYNC_FISCAL_JOURNAL_TEXT_MAX).nullable(),
    /** Z report only. */
    zTotals: exports.SyncFiscalJournalZTotals.nullable(),
    /**
     * VL-353 — three optional keys a store's document feed reads. Optional and
     * never required of a type: a till that predates them sends none, and a
     * Back Office or Link that predates them strips them.
     *
     * They describe the document; they are not the document. A value outside
     * its bounds (a display name longer than 128 characters, a tax row without
     * a name) therefore reads as ABSENT — `.catch(undefined)` — and never
     * refuses the record: a refusal here is permanent, so the register's Z
     * report or cash document would be dead-lettered on the till over a label.
     * The same rule as the `rl.export` facts (`document-feed.ts`).
     *
     * `cashierName` is the display name of `cashierId` at the time.
     */
    cashierName: zod_1.z.string().trim().min(1).max(128).nullable().optional().catch(undefined),
    /** Service cash in / out: the drawer's cash balance the register reported right after it. */
    cashBalanceAfterMinor: pricing_js_1.MoneyMinor.nullable().optional().catch(undefined),
    /** Z report: the tax table the till configured into the register, by slot. */
    zTaxTable: zod_1.z
        .array(zod_1.z.object({
        slot: zod_1.z.number().int().min(0).max(10),
        letter: zod_1.z.string().trim().min(1).max(16),
        ratePercent: DecimalPercent,
        name: zod_1.z.string().trim().min(1).max(128),
    }))
        .max(11)
        .optional()
        .catch(undefined),
});
exports.SyncFiscalJournalRecord = SyncFiscalJournalRecordBase.superRefine((record, ctx) => {
    const type = record.documentType;
    const isCash = type === 'cash_in' || type === 'cash_out';
    const isMarker = type === 'offline_session_open' || type === 'offline_session_close';
    if (isCash) {
        // Same guard as `PositiveMoneyMinor`: a malformed string must reach a
        // rejection, never a `BigInt()` throw.
        const amount = record.amountMinor;
        if (amount === null || !/^\d+$/.test(amount) || BigInt(amount) <= 0n) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['amountMinor'],
                message: 'a cash in / cash out carries a positive amountMinor',
            });
        }
    }
    else if (record.amountMinor !== null) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['amountMinor'],
            message: 'only a cash in / cash out carries an amount',
        });
    }
    if (isMarker && record.offlineSession === null) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['offlineSession'],
            message: 'an offline session marker carries its session',
        });
    }
    if (record.zTotals !== null && type !== 'z_report') {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['zTotals'],
            message: 'only a Z report carries Z totals',
        });
    }
});
/** Records per upload — the till sends one per request today. */
exports.SYNC_FISCAL_JOURNAL_BATCH_MAX = 500;
exports.SyncFiscalJournalUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncFiscalJournalRecord).min(1).max(exports.SYNC_FISCAL_JOURNAL_BATCH_MAX),
});
exports.SyncFiscalJournalUploadResponse = exports.SyncBatchAck;
// ---------- Upload — Shift events (Sprint 4 stub-501; full Sprint 5) ----------
exports.SyncShiftEventRecord = zod_1.z.object({
    clientUuid: zod_1.z.string().min(1).max(64),
    shiftId: zod_1.z.string().min(1),
    cashierId: zod_1.z.string().min(1),
    occurredAt: zod_1.z.string().datetime(),
    /** open / close / cash-drop / cash-count / pause / resume — Sprint 5 narrows. */
    kind: zod_1.z.enum(['open', 'close', 'cash_drop', 'cash_count', 'pause', 'resume']),
    /** Amounts in smallest currency unit; per-event semantics. */
    amountMinor: pricing_js_1.MoneyMinor.nullable(),
    notes: zod_1.z.string().max(1024).nullable(),
});
exports.SyncShiftEventsUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncShiftEventRecord).min(1).max(exports.SYNC_PAGE_SIZE_MAX),
});
exports.SyncShiftEventsUploadResponse = exports.SyncBatchAck;
// ---------- Upload — Age verifications (Sprint 4 stub-501; full Sprint 5+) ----------
exports.SyncAgeVerificationRecord = zod_1.z.object({
    clientUuid: zod_1.z.string().min(1).max(64),
    occurredAt: zod_1.z.string().datetime(),
    cashierId: zod_1.z.string().nullable(),
    shiftId: zod_1.z.string().nullable(),
    /** Country-pack age category id (e.g. `alcohol`, `tobacco`). */
    categoryId: zod_1.z.string().min(1),
    /** Minimum age that applied at sale time. */
    minimumAge: zod_1.z.number().int().min(0).max(99),
    /** Outcome — accepted / refused / overridden by attendant. */
    outcome: zod_1.z.enum(['accepted', 'refused', 'attendant_override']),
    /** Optional attendant id when overridden. */
    attendantId: zod_1.z.string().nullable(),
});
exports.SyncAgeVerificationsUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncAgeVerificationRecord).min(1).max(exports.SYNC_PAGE_SIZE_MAX),
});
exports.SyncAgeVerificationsUploadResponse = exports.SyncBatchAck;
// ---------- Upload — Weight samples (Sprint 4 stub-501; full Sprint 8) ----------
exports.SyncWeightSampleRecord = zod_1.z.object({
    clientUuid: zod_1.z.string().min(1).max(64),
    itemId: zod_1.z.string().min(1),
    capturedAt: zod_1.z.string().datetime(),
    observedGrams: zod_1.z.number().int().positive(),
    /** Weight standard at capture time (for self-learning baseline). */
    expectedGrams: zod_1.z.number().int().positive().nullable(),
    /** Sample disposition — accepted (within tolerance), flagged, etc. */
    outcome: zod_1.z.enum(['accepted', 'flagged_under', 'flagged_over', 'auto_corrected']),
});
exports.SyncWeightSamplesUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncWeightSampleRecord).min(1).max(exports.SYNC_PAGE_SIZE_MAX),
});
exports.SyncWeightSamplesUploadResponse = exports.SyncBatchAck;
// ---------- Upload — Approval Requests (Sprint 9) ----------
/**
 * SCO terminals author attendant approval requests locally
 * (weight mismatch, age restriction, unknown item, etc.) and upload
 * them in batches via `/sync/approval-requests`. Idempotent on
 * `(terminalId, clientUuid)`. The per-record shape lives in
 * `./approvals.ts` as `AttendantRequestUpload` and the cap
 * (1000 per batch) is the SCO-emission-rate-appropriate ceiling.
 */
exports.SyncApprovalRequestsUploadRequest = approvals_js_1.AttendantRequestsUploadRequest;
exports.SyncApprovalRequestsUploadResponse = exports.SyncBatchAck;
exports.SYNC_APPROVALS_BATCH_MAX = approvals_js_1.ATTENDANT_REQUESTS_UPLOAD_MAX;
// ---------- Stub-501 envelope (TRS §11.7 future-domain handling) ----------
/**
 * The four upload domains whose underlying BOS implementation isn't
 * ready yet (transactions, shift-events, age-verifications,
 * weight-samples) ship with their POST endpoints registered but
 * returning 501 Not Implemented + this envelope. Terminals fail
 * soft against this stable shape: they hold the records in the
 * local queue, log a warning, and retry after the suggested
 * `Retry-After` (which BOS sets to a value >> the next minor
 * release).
 */
exports.SyncNotImplementedResponse = zod_1.z.object({
    statusCode: zod_1.z.literal(501),
    message: zod_1.z.string().min(1),
    /** Sprint that will implement this endpoint, e.g. "Sprint 5". */
    targetSprint: zod_1.z.string().min(1),
    /**
     * RFC-7231 Retry-After value in seconds. Terminals MUST honour it
     * (within reason) — typically a multi-day defer until app-update
     * adds a wired-up endpoint client.
     */
    retryAfterSeconds: zod_1.z.number().int().positive(),
});
// ---------- Domain capability map ----------
// ---------- Sync lag surface (Sprint 4 ticket 4.5 / TRS §11.8) ----------
/**
 * Per-domain sync-lag classification (TRS §11.8). How a domain is graded
 * depends on its direction (RL-252).
 *
 * **Pull domains** (BOS → terminal) are graded on freshness plus an
 * explicit terminal-reported failure, because a confirmed poisoned cursor
 * can keep returning successful empty pages:
 * - `green`   — last success within 15 min (default warn threshold)
 * - `yellow`  — last success between 15 min and 60 min OR a
 *               `lastFailureCode` is present
 * - `red`     — last success > 60 min (default alert threshold) OR
 *               telemetry has never reported success for this domain
 * - `unknown` — the reported `lastSuccessAt` does not parse
 *
 * **Push domains** (terminal → BOS: transactions, shift-events,
 * age-verifications, weight-samples, approvals, audit-log, telemetry,
 * terminal-logs, payments, loyalty-event, sco-approval-resolved) are graded
 * on queue state, because `lastSuccessAt` only
 * advances when the terminal actually has something to send — an idle
 * till cannot refresh them at all, and an empty outbox is healthy:
 * - `green`   — nothing queued, no recent failure (`lastSuccessAt` may be
 *               null: a till that has never had anything to push is fine)
 * - `yellow`  — `lastFailureCode` set; draining, but not cleanly
 * - `red`     — `deadLetterCount > 0`; records that will never be sent
 * - `unknown` — `deadLetterCount` unusable, so queue health cannot be judged
 *
 * Legacy terminals omit `queueStateVersion` and used `deadLetterCount` for
 * consecutive failures. BOS treats a positive legacy value as yellow, never
 * as a durable dead letter; version 1 makes the red distinction authoritative.
 *
 * At snapshot level, `unknown` additionally means the terminal has never
 * uploaded telemetry at all (freshly activated, before its first sync
 * round-trip) — that snapshot carries no domains.
 */
exports.SyncLagLevel = zod_1.z.enum(['green', 'yellow', 'red', 'unknown']);
exports.SyncLagDomainState = zod_1.z.object({
    domain: zod_1.z.string().min(1),
    lastSuccessAt: zod_1.z.string().datetime().nullable(),
    lagSeconds: zod_1.z.number().int().nullable(),
    level: exports.SyncLagLevel,
});
/**
 * Kitchen station alert state derived from the last telemetry (FN-92):
 * red when the broker is not consuming (or telemetry is stale), yellow when
 * statuses are queued in the outbox or the printer is not ready, green
 * otherwise. Absent for terminals that never reported `health.kitchen`.
 */
exports.SyncLagKitchenState = zod_1.z.object({
    level: exports.SyncLagLevel,
    reason: zod_1.z.string().nullable(),
    broker: exports.KitchenBrokerHealth,
    printer: exports.KitchenPrinterHealth,
    activeOrders: zod_1.z.number().int().min(0).nullable(),
});
exports.SyncLagSnapshot = zod_1.z.object({
    terminalId: zod_1.z.string(),
    /**
     * Last telemetry receive time. Null when the terminal hasn't
     * uploaded any telemetry yet — the per-domain entries will all
     * be `unknown`.
     */
    reportedAt: zod_1.z.string().datetime().nullable(),
    domains: zod_1.z.array(exports.SyncLagDomainState),
    /** Worst level across all domains; useful for one-cell list UI. */
    worstLevel: exports.SyncLagLevel,
    /** Server clock at compute time. */
    computedAt: zod_1.z.string().datetime(),
    kitchen: exports.SyncLagKitchenState.optional(),
    /**
     * RL-267: shift-boundary parameters as the till last reported them, so
     * Back Office can show which value a till is operating under and what it
     * is holding. Absent when the till never reported them.
     */
    shiftBoundaryParams: zod_1.z.array(terminal_params_js_1.TerminalShiftBoundaryParamState).optional(),
    /**
     * RL-928: the capabilities the till's last telemetry reported (see
     * `SyncTelemetryRecord.capabilities`). Absent when the till never reported
     * any — an older build — so the admin can say "not on this till version".
     */
    capabilities: zod_1.z.array(zod_1.z.string()).optional(),
    /**
     * SSC-260: the SecureScale weight copy as the lane last reported it, for
     * staff. Absent when the lane never reported one. Not graded.
     */
    secureScaleCopy: exports.SecureScaleCopyTelemetryHealth.optional(),
});
// ---------- Upload — Kitchen order events (FN-93, ADR-0013) ----------
exports.KitchenOrderEventStatus = zod_1.z.enum([
    'queued',
    'preparing',
    'ready',
    'collected',
    'cancelled',
    'noShow',
]);
exports.KitchenOrderEventLine = zod_1.z.object({
    productId: zod_1.z.number().int(),
    name: zod_1.z.string().min(1).max(255),
    quantity: zod_1.z.number().int().min(1),
    unitPriceMinor: zod_1.z.number().int(),
});
/**
 * One order transition on a kitchen station, with the order as it stood.
 * The station is the system of record; BOS keeps the newest snapshot per
 * order and every event, read-only (no commands flow back).
 */
exports.SyncKitchenOrderEventRecord = zod_1.z.object({
    clientUuid: zod_1.z.string().min(1).max(64),
    orderId: zod_1.z.string().min(1).max(64),
    orderNumber: zod_1.z.string().min(1).max(64),
    displayNumber: zod_1.z.string().min(1).max(32),
    source: zod_1.z.enum(['app', 'station']),
    fromStatus: exports.KitchenOrderEventStatus.nullable(),
    toStatus: exports.KitchenOrderEventStatus,
    occurredAt: zod_1.z.string().datetime(),
    actor: zod_1.z.string().min(1).max(64),
    note: zod_1.z.string().max(512).nullable(),
    storeId: zod_1.z.number().int(),
    totalMinor: zod_1.z.number().int(),
    currency: zod_1.z.string().length(3),
    /** Masked (`3809 *** 45`); the raw identifier never leaves the station. */
    customerLabel: zod_1.z.string().max(64).nullable(),
    pickupAt: zod_1.z.string().datetime(),
    createdAt: zod_1.z.string().datetime(),
    providerStatus: zod_1.z.string().max(32).nullable(),
    paymentState: zod_1.z.enum(['notRequired', 'paid', 'hold', 'failed']),
    stickersPrinted: zod_1.z.number().int().min(0),
    lastError: zod_1.z.string().max(512).nullable(),
    lines: zod_1.z.array(exports.KitchenOrderEventLine).default([]),
});
exports.SyncKitchenOrderEventsUploadRequest = zod_1.z.object({
    records: zod_1.z.array(exports.SyncKitchenOrderEventRecord).min(1).max(exports.SYNC_PAGE_SIZE_MAX),
});
exports.SyncKitchenOrderEventsUploadResponse = exports.SyncBatchAck;
/** Admin read model (FN-93): the newest snapshot of one order. */
exports.KitchenOrderSummary = zod_1.z.object({
    id: zod_1.z.string(),
    terminalId: zod_1.z.string(),
    terminalCode: zod_1.z.string().nullable(),
    locationId: zod_1.z.string().nullable(),
    storeId: zod_1.z.number().int(),
    orderId: zod_1.z.string(),
    orderNumber: zod_1.z.string(),
    displayNumber: zod_1.z.string(),
    source: zod_1.z.enum(['app', 'station']),
    status: exports.KitchenOrderEventStatus,
    paymentState: zod_1.z.enum(['notRequired', 'paid', 'hold', 'failed']),
    providerStatus: zod_1.z.string().nullable(),
    customerLabel: zod_1.z.string().nullable(),
    totalMinor: zod_1.z.number().int(),
    currency: zod_1.z.string(),
    pickupAt: zod_1.z.string().datetime(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
    stickersPrinted: zod_1.z.number().int(),
    lastError: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.KitchenOrderEventLine),
});
exports.KitchenOrderEventView = zod_1.z.object({
    id: zod_1.z.string(),
    fromStatus: exports.KitchenOrderEventStatus.nullable(),
    toStatus: exports.KitchenOrderEventStatus,
    occurredAt: zod_1.z.string().datetime(),
    actor: zod_1.z.string(),
    note: zod_1.z.string().nullable(),
    receivedAt: zod_1.z.string().datetime(),
});
exports.ListKitchenOrdersResponse = zod_1.z.object({
    orders: zod_1.z.array(exports.KitchenOrderSummary),
    total: zod_1.z.number().int().min(0),
});
/** Canonical list of sync domain ids, matching `capabilities` keys in handshake. */
exports.SYNC_DOMAINS = [
    'sync.handshake',
    'sync.catalog',
    'sync.catalog-hotkeys',
    // VL-260 — operator-uploaded hotkey glyphs, delivered as content rather
    // than fetched as assets. Snapshot feed with the same ?since=/304 fast
    // path the hotkey tree uses.
    'sync.hotkey-icons',
    'sync.prices',
    'sync.promotions',
    'sync.cashiers',
    'sync.weight-standards',
    'sync.country-pack',
    'sync.terminal-config',
    'sync.i18n',
    'sync.receipt-config',
    'sync.transactions',
    'sync.receipt-link-token',
    'sync.shift-events',
    'sync.age-verifications',
    'sync.weight-samples',
    'sync.telemetry',
    'sync.audit-log',
    'sync.approvals',
    // VL-134 — the connector-sourced store catalogue: a whole-snapshot
    // replacement feed rather than a delta; see `varus-catalogue.ts` for why,
    // and for the readiness contract that gates it. RL-466 gave it a neutral
    // name, `sync.store-catalogue` (`GET /sync/store-catalogue`); the old name
    // stays as a deprecated alias for one release window — see
    // `DEPRECATED_SYNC_DOMAIN_ALIASES` below.
    'sync.store-catalogue',
    /** @deprecated RL-466 — alias of `sync.store-catalogue`, same pages. */
    'sync.varus-catalogue',
    // RL-452 — the store's connector ownership (and, later, its Link address and
    // the till's store pass). See `store-link.ts`.
    'sync.store-link',
    // RL-540 — upload of the register's non-receipt fiscal documents (Z / X
    // reports, service cash in / out, offline-session markers). A till uploads
    // only once Back Office advertises it `ready`; see `SyncFiscalJournalRecord`.
    'sync.fiscal-journal',
    // VL-250 — not a route: the `cash-count` kind on `/sync/shift-events`. A
    // till uploads drawer counts only once Back Office advertises it `ready`
    // (the RL-540 capability-gated upload), since an older Back Office refuses
    // the kind permanently.
    'sync.cash-count',
    // VL-285 — the store's excise-label replica (`GET /sync/excise-labels`): a
    // delta with a periodic full walk; see `excise-labels.ts`.
    'sync.excise-labels',
    // VL-353 — not a route: a store whose Link feeds its documents to a message
    // broker. A till attaches the `rl.export` facts, uploads cancellations and
    // copies its fiscal journal to the Link only while Back Office advertises
    // it `ready`; see `document-feed.ts`.
    'sync.document-feed',
    // ATBL-449 — the ATB store's weight ranges read from WinSCOServer
    // (`GET /sync/atb-weight-ranges`): a revision-cursor delta with tombstones;
    // see `atb-weight-database.ts`.
    'sync.atb-weight-ranges',
];
/**
 * Deprecated domain names still served, mapped to the name that replaces them
 * (RL-466). Both names are served by the same handler with identical pages,
 * cursors and auth, so a till may switch at any point, even mid-walk.
 *
 * `sync.varus-catalogue` named a customer on the wire. It is removed once every
 * till of every tenant that has the `connectors` module enabled runs a
 * terminals build that pulls `sync.store-catalogue` (RL-465), and Back Office
 * has logged no pull through the alias for a full release after that.
 */
exports.DEPRECATED_SYNC_DOMAIN_ALIASES = {
    'sync.varus-catalogue': 'sync.store-catalogue',
};
//# sourceMappingURL=sync.js.map